import React, { useEffect, useRef, useState } from "react";
import { useCallback, useMemo } from "react";
import { createPortal } from "react-dom";
import ProductManagementSubmisionIcon from "../icons/BusinessHub/ProductManegementsubmissionIcon";
import "../styles/ProductSubmission.css";
import EyeView from "../icons/BusinessHub/EyeViewOpened";
import FilterIcon from "../icons/BusinessHub/FilterIcon";
import ExportAndPrintIcon from "../icons/BusinessHub/ExportAndPrintIcon";
import PrintIcon from "../icons/PrintIcon";
import GloablButton from "./GloablButton";
import SearchIcon from "../icons/BusinessHub/SearchIcon";
import CameraIcon from "../icons/BusinessHub/CameraIcon";
import ResubmitIcon from "../icons/BusinessHub/ResubmitIcon";
import RejectedIcon from "../icons/BusinessHub/RejectedIcon";
import ApprovedIcon from "../icons/BusinessHub/ApprovedIcon";
import ResubmitionYellow from "../icons/BusinessHub/ResubmitionYellowIcon";
import InternalNotesIcon from "../icons/BusinessHub/InternalNotesIcon";
import ReviewActiveLog from "../icons/BusinessHub/ReviewActivityLogIcon";
import TrachIcon from "../icons/SignInIcon/TrachIcon";
import FaulseIcon from "../icons/BusinessHub/FaulseIcon";
import Worning from "../icons/BusinessHub/warningExlamationIcon";
import ApprovedBigIcon from "../icons/BusinessHub/BigApprovedIcon";
import productPic from "../assests/ProductImages/productpic.svg";
import { userService } from "../services/userService";
import ProductController from "../controllers/ProductController";
import DownloadIcon from "../icons/BusinessHub/downloadIcon";
import Utils from "../utils/Utils";
import PointIcon from "../icons/BusinessHub/3pointsIcon";
import TrashIcon from "../icons/BusinessHub/TrashIcon";
import CloseIcon from "../icons/SignInIcon/closeIcon";
import DateRangePicker from "./DateRangePicker";
import CustomDropdown from "./StatusDropdown";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon";
import ArrowBackIcon from "../icons/BusinessHub/ArrowBackIcon";
import ArrowFront from "../icons/BusinessHub/ArrowFront";
import XIcon from "../icons/XIcon";
import DateIcon from "../icons/BusinessHub/DateIcon";
import SettingsIcon from "../icons/BusinessHub/SettingsIcon";
import PicIcon from "../icons/PicIcon";
import VideoIcon from "../icons/VideoIcon";
import DocIcon from "../icons/DocIcon";
import UploadButtonIcon from "../icons/BusinessHub/Uploadbutton";
import EditDetails from "../icons/BusinessHub/EditDetails";
import useTableNavigationState from "../utils/useTableNavigationState";

const AI_JOB_CACHE_KEY = "azalea-admin-ai-jobs";
const INTERNAL_NOTES_MAX_LENGTH = 1000;
const PRODUCT_SUBMISSION_TABLE_DEFAULTS = {
  page: 1,
  size: 10,
  search: "",
  from: "",
  to: "",
  category: "",
  status: "",
  employeeName: "",
  onlyAzalea: false,
};
const PRODUCT_SUBMISSION_RETURN_STATE_KEY =
  "azalea.productSubmissions.returnTableState";
const PRODUCT_SUBMISSION_RETURN_PENDING_KEY =
  "azalea.productSubmissions.returnPending";

const limitInternalNotes = (value) =>
  String(value || "").slice(0, INTERNAL_NOTES_MAX_LENGTH);

const readStoredProductSubmissionTableState = () => {
  try {
    const storedState = window.sessionStorage.getItem(
      PRODUCT_SUBMISSION_RETURN_STATE_KEY,
    );

    return storedState ? JSON.parse(storedState) : null;
  } catch (error) {
    return null;
  }
};
const saveProductSubmissionTableState = (state) => {
  try {
    window.sessionStorage.setItem(
      PRODUCT_SUBMISSION_RETURN_STATE_KEY,
      JSON.stringify(state),
    );
  } catch (error) {}
};

const markProductSubmissionReturnPending = () => {
  try {
    window.sessionStorage.setItem(PRODUCT_SUBMISSION_RETURN_PENDING_KEY, "1");
  } catch (error) {}
};

const consumeProductSubmissionReturnPending = () => {
  try {
    const isPending =
      window.sessionStorage.getItem(PRODUCT_SUBMISSION_RETURN_PENDING_KEY) ===
      "1";
    window.sessionStorage.removeItem(PRODUCT_SUBMISSION_RETURN_PENDING_KEY);

    return isPending;
  } catch (error) {
    return false;
  }
};

function ProductSubmission() {
  const { tableState, encryptedState, buildUrl, navigateWithTableState } =
    useTableNavigationState({
      defaults: PRODUCT_SUBMISSION_TABLE_DEFAULTS,
    });
  const [isTableStateInitialized, setIsTableStateInitialized] = useState(false);
  const [AIInhancment, setAIInhancment] = useState(false);
  const [photoEnhance, setPhotoEnhance] = useState(false);
  const [videoEnhance, setVideoEnhance] = useState(false);
  const [docEnhance, setDocEnhance] = useState(false);
  const [iconFill, setIconFill] = useState("#4072C8");
  const [ProductDetails, seProductDetails] = useState([]);
  const [aiVideoProductDetails, setAiVideoProductDetails] = useState([]);
  const [BulkProds, setBulkProds] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIconFill("white");
      } else {
        setIconFill("#4072C8");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const normalizeStoredId = (value, ...keys) => {
    if (value === null || value === undefined) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
    if (typeof value === "object") {
      for (const key of keys) {
        const candidate = value?.[key];
        if (
          candidate !== null &&
          candidate !== undefined &&
          String(candidate).trim()
        ) {
          return String(candidate).trim();
        }
      }
    }
    return "";
  };

  const getJwtString = () => {
    const raw = userService.getUserData?.() ?? userService.getUser?.();
    if (!raw) return "";
    if (typeof raw === "string") return raw;
    return raw?.jwt ?? raw?.token ?? "";
  };

  const jwt = getJwtString();
  const parsedJwt = (() => {
    try {
      return jwt ? Utils.parseJwt(jwt) : null;
    } catch (e) {
      return null;
    }
  })();
  const companyIDFromJwt = parsedJwt?.userDetails
    ? Object.keys(parsedJwt.userDetails)[0]
    : null;
  const storedComp = userService.getCompID?.();
  const companyID =
    normalizeStoredId(storedComp, "companyId", "companyID") ||
    normalizeStoredId(companyIDFromJwt) ||
    normalizeStoredId(parsedJwt?.companyId) ||
    normalizeStoredId(parsedJwt?.companyID);
  const storedBP = userService.getBPID?.();
  const businessProfileID =
    normalizeStoredId(storedBP, "businessProfileID", "busienssProfileID") ||
    normalizeStoredId(parsedJwt?.userDetails?.[companyID]?.businessProfileID) ||
    normalizeStoredId(parsedJwt?.userDetails?.[companyID]?.busienssProfileID);
  const [rejectReason, setRejectReason] = useState("");
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const [displayedRows, setdisplayedRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageInputValue, setPageInputValue] = useState("");
  const [isPageInputFocused, setIsPageInputFocused] = useState(false);
  const [lastListPage, setLastListPage] = useState(1);
  const [serverTotalPages, setServerTotalPages] = useState(1);
  const [serverTotalElements, setServerTotalElements] = useState(0);
  const [hasLoadedTableStatePage, setHasLoadedTableStatePage] =
    useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [showAllCategories, setShowAllCategories] = useState(false);
  const fromDatePickerRef = useRef(null);
  const toDatePickerRef = useRef(null);
  const filterWrapRef = useRef(null);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [internalNotes, setInternalNotes] = useState("");
  const [lastSavedNotes, setLastSavedNotes] = useState("");
  const [notesSaving, setNotesSaving] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [videoDragging, setVideoDragging] = useState(false);
  const videoInputRef = useRef(null);
  const productImageInputRef = useRef(null);

  const [isResubmitPopupOpen, setIsResubmitPopupOpen] = useState(false);
  const [resubmitReason, setResubmitReason] = useState("");
  const [notifySubmitter, setNotifySubmitter] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);

  const [isRejectOpen, setIsRejectOpen] = useState(false);
  const [notifyRejectSubmitter, setNotifyRejectSubmitter] = useState(true);
  const [rejectValidationError, setRejectValidationError] = useState("");

  const [approveNotes, setApproveNotes] = useState("");
  const [approveNotifySubmitter, setApproveNotifySubmitter] = useState(true);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isPrintConfigOpen, setIsPrintConfigOpen] = useState(false);
  const [exportFormat, setExportFormat] = useState("PDF");
  const [exportScope, setExportScope] = useState("ALL");
  const [printSize, setPrintSize] = useState("SMALL");
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const setLimitedInternalNotes = (value) =>
    setInternalNotes(limitInternalNotes(value));
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [printPreviewSrc, setPrintPreviewSrc] = useState("");
  const [imageEnhancing, setImageEnhancing] = useState(false);
  const [imageDeleting, setImageDeleting] = useState(false);
  const [imageAdding, setImageAdding] = useState(false);
  const [aiJobs, setAiJobs] = useState({});

  // UI-only errors (no API)
  const [actionError, setActionError] = useState("");
  const [listLoading, setListLoading] = useState(false);
  const [validateOnly, setValidateOnly] = useState(false);
  const [bulkImportFile, setBulkImportFile] = useState(null);
  const [bulkImportMessage, setBulkImportMessage] = useState("");
  const [bulkImportMessageType, setBulkImportMessageType] = useState("");
  const [bulkImportResult, setBulkImportResult] = useState(null);
  const [bulkImportLoading, setBulkImportLoading] = useState(false);
  const [draftFilters, setDraftFilters] = useState({
    search: "",
    from: "",
    to: "",
    category: "",
    status: "",
    
    onlyAzalea: false,
    employeeName: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    search: "",
    from: "",
    to: "",
    category: "",
    status: "",
    onlyAzalea: false,
    employeeName: "",
  });
  const currentTableState = useMemo(
    () => ({
      page: currentPage,
      size: rowsPerPage,
      search: appliedFilters.search,
      from: appliedFilters.from,
      to: appliedFilters.to,
      category: appliedFilters.category,
      status: appliedFilters.status,
      onlyAzalea: appliedFilters.onlyAzalea,
      employeeName: appliedFilters.employeeName,
    }),
    [appliedFilters, currentPage, rowsPerPage],
  );

  const createProductEditNavigation = useCallback(
    (product) => {
      const productId =
        product?.productId ||
        product?.productID ||
        product?.raw?.productId ||
        product?.raw?.productID ||
        product?.id;
      const navigationData = {
        returnPath: "/product-submissions",
        returnTableState: currentTableState,
        sourcePage: "product-submissions",
        isEditing: true,
        productID: productId,
        productId,
        companyId:
          product?.companyId ||
          product?.companyID ||
          product?.raw?.companyId ||
          product?.raw?.companyID ||
          userService.getCompID(),
        businessProfileID:
          product?.businessProfileID ||
          product?.busienssProfileID ||
          product?.raw?.businessProfileID ||
          product?.raw?.busienssProfileID ||
          userService.getBPID(),
      };
      const path = `/product-catalog/details?data=${encodeURIComponent(
        Utils.AESEncrypt(JSON.stringify(navigationData)),
      )}`;

      return {
        path,
        state: navigationData,
      };
    },
    [currentTableState],
  );

  const [products, setProducts] = useState([]);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);
  const [actionMenuPosition, setActionMenuPosition] = useState({
    top: 0,
    left: 0,
  });

  const [summaryCounts, setSummaryCounts] = useState({
    total: 0,
    pending: 0,
    approved: 0,
  });

  // useEffect(() => {
  //   const total = Number(serverTotalElements || products.length || 0);
  //   const pendingFromList = products.filter(
  //     (p) => String(p.status || "").toUpperCase() === "PENDING",
  //   ).length;
  //   const approvedFromList = products.filter(
  //     (p) => String(p.status || "").toUpperCase() === "APPROVED",
  //   ).length;
  //   const currentPageStatuses = Array.from(
  //     new Set(products.map((p) => String(p.status || "").toUpperCase())),
  //   ).filter(Boolean);

  //   let pending = pendingFromList;
  //   let approved = approvedFromList;

  //   // If backend returns paginated rows of a single status, reflect server total.
  //   if (total > products.length && currentPageStatuses.length === 1) {
  //     if (currentPageStatuses[0] === "PENDING") pending = total;
  //     if (currentPageStatuses[0] === "APPROVED") approved = total;
  //   }

  //   setSummaryCounts({ total, pending, approved });
  // }, [products, serverTotalElements]);

  const summaryCards = [
    {
      label: "Total Submissions",
      value: String(summaryCounts.total ?? 0),
      tone: "default",
    },
    {
      label: "Pending Review",
      value: String(summaryCounts.pending ?? 0),
      tone: "pending",
    },
    {
      label: "Approved",
      value: String(summaryCounts.approved ?? 0),
      tone: "approved",
    },
  ];
  const handleBulkImport = async () => {
    if (!bulkImportFile || bulkImportLoading) return;

    const formData = new FormData();
    formData.append("file", bulkImportFile);
    formData.append("companyId", companyID || userService.getCompID());
    formData.append("userId", Utils.parseJwt(userService.getUser()).id);
    formData.append("validateOnly", validateOnly);

    setBulkImportLoading(true);
    setBulkImportMessage("");
    setBulkImportMessageType("");
    setBulkImportResult(null);

    try {
      const res = await ProductController.bulkImportProductsCsv({
        Authorization: userService.getUser(),
        formData,
      });

      if (res?.response) {
        setBulkImportMessageType("error");
        setBulkImportResult(null);
        setBulkImportMessage(
          res.response?.data?.message ||
            res.response?.data?.error ||
            "Bulk product import failed. Please try again.",
        );
        return;
      }

      const responseData = res?.data;
      setBulkImportMessageType(
        responseData?.success === false ? "error" : "success",
      );
      setBulkImportResult(responseData || null);
      setBulkImportMessage(responseData?.message || "");
    } catch (error) {
      setBulkImportMessageType("error");
      setBulkImportResult(null);
      setBulkImportMessage(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Bulk product import failed. Please try again.",
      );
    } finally {
      setBulkImportLoading(false);
    }
  };

  const handleBulkImportFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setBulkImportFile(file);
    setBulkImportMessage("");
    setBulkImportMessageType("");
    setBulkImportResult(null);
  };

  const closeBulkImportPopup = () => {
    if (bulkImportLoading) return;
    setBulkProds(false);
    setBulkImportFile(null);
    setBulkImportMessage("");
    setBulkImportMessageType("");
    setBulkImportResult(null);
  };

  const getBulkImportErrorText = (error) => {
    if (typeof error === "string") return error;
    if (!error || typeof error !== "object") return "Unknown import error";

    const rowPrefix = error.rowNumber ? `Row ${error.rowNumber}: ` : "";
    return (
      rowPrefix +
      (error.message || error.error || error.reason || JSON.stringify(error))
    );
  };
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    const getAllCategs = async () => {
      try {
        const getAllCategs = await ProductController.getAllCategories({
          Authorization: userService.getUser(),
        });
        const categories = Array.isArray(getAllCategs?.data)
          ? getAllCategs.data
          : [];
        setCategoryOptions(
          categories.filter(
            (category) => category?.categoryName && category?.categoryId,
          ),
        );
      } catch (error) {
        console.log(error);
      }
    };
    getAllCategs();
  }, []);
  const statusOptions = ["Approved", "Pending", "Rejected"];
  const rowsPerPageOptions = [10, 25, 50, 100];
  const truncateTableValue = (value, maxLength = 40) => {
    const text = String(value || "");
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };
  const truncateProductName = (name) =>
    String(name??"");
  const truncateSku = (sku, maxLength = 20) => {
    const value = String(sku || "");
    return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
  };
  const exportFormatOptions = [
    { key: "PDF", title: "PDF", subtitle: "Document" },
    { key: "CSV", title: "CSV", subtitle: "Spreadsheet" },
    { key: "EXCEL", title: "Excel", subtitle: "Workbook" },
    { key: "PRINT", title: "Print", subtitle: "Direct Print" },
  ];
  const printSizeOptions = [
    { key: "SMALL", label: "Small", size: "20mm x 20mm" },
    { key: "MEDIUM", label: "Medium", size: "40mm x 40mm" },
    { key: "LARGE", label: "Large", size: "80mm x 80mm" },
    { key: "XLARGE", label: "X-Large", size: "120mm x 120mm" },
  ];

  const visibleCategoryOptions = showAllCategories
    ? categoryOptions
    : categoryOptions.slice(0, 3);

  const normalizeCategoryValue = (value) =>
    String(value || "")
      .trim()
      .toUpperCase();

  const getCategoryNameById = (categoryId) =>
    categoryOptions.find(
      (category) =>
        normalizeCategoryValue(category?.categoryId) ===
        normalizeCategoryValue(categoryId),
    )?.categoryName || "";

  // âœ… UI-only filtering (optional)
  // const filteredProducts = products.filter((p) => {
  //   const s = appliedFilters.search.trim().toLowerCase();
  //   const matchSearch =
  //     !s ||
  //     String(p.name || "")
  //       .toLowerCase()
  //       .includes(s) ||
  //     String(p.submittedBy || "")
  //       .toLowerCase()
  //       .includes(s) ||
  //     String(p.sku || "")
  //       .toLowerCase()
  //       .includes(s);

  //   const appliedCategoryId = normalizeCategoryValue(appliedFilters.category);
  //   const appliedCategoryName = getCategoryNameById(appliedFilters.category);
  //   const matchCategory =
  //     !appliedFilters.category ||
  //     [p.categoryId, p.raw?.categoryId, p.raw?.basicInfo?.categoryId].some(
  //       (categoryValue) =>
  //         normalizeCategoryValue(categoryValue) === appliedCategoryId,
  //     ) ||
  //     [
  //       p.category,
  //       p.raw?.categoryName,
  //       p.raw?.basicInfo?.category,
  //       p.raw?.basicInfo?.categoryName,
  //     ].some((categoryValue) => {
  //       const categoryText = String(categoryValue || "").trim();
  //       return (
  //         appliedCategoryName &&
  //         categoryText.toLowerCase() === appliedCategoryName.toLowerCase()
  //       );
  //     });

  //   const matchStatus =
  //     !appliedFilters.status ||
  //     String(p.status || "").toLowerCase() ===
  //       appliedFilters.status.toLowerCase();

  //   return matchSearch && matchCategory && matchStatus;
  // });
  const filteredProducts = products;

  const [openImagePopup, setOpenImagePopup] = useState(false);
  const [replaceOriginal, setReplaceOriginal] = useState(false);

  const [activeImages, setActiveImages] = useState([]);
  const [activeProduct, setActiveProduct] = useState(null);
  const [showChangeHistory, setShowChangeHistory] = useState(false);
  const isAiEnhancementViewOpen = AIInhancment || openImagePopup;
  // const [replaceOriginal, setReplaceOriginal] = useState(false);
  // const totalRows = Math.max(serverTotalElements || 0, filteredProducts.length);
  // const clientTotalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  // const totalPages = Math.max(1, serverTotalPages || 0, clientTotalPages);
  // const shouldUseClientPagination = filteredProducts.length > rowsPerPage;
  // const currentRows = shouldUseClientPagination
  //   ? filteredProducts.slice(
  //       (currentPage - 1) * rowsPerPage,
  //       currentPage * rowsPerPage,
  //     )
    // : filteredProducts;
  const totalRows = serverTotalElements;
const totalPages = Math.max(1, serverTotalPages);
const currentRows = products;
  

  const currentRowIds = currentRows.map((row) => String(row.id));
  const isAllCurrentRowsSelected =
    currentRowIds.length > 0 &&
    currentRowIds.every((id) => selectedRowIds.includes(id));

  useEffect(() => {
    if (isTableStateInitialized) return;

    const shouldUseStoredState =
      !encryptedState && consumeProductSubmissionReturnPending();
    const restoredTableState = shouldUseStoredState
      ? {
          ...PRODUCT_SUBMISSION_TABLE_DEFAULTS,
          ...(readStoredProductSubmissionTableState() || {}),
        }
      : tableState;
    const restoredFilters = {
      search: restoredTableState.search || "",
      from: restoredTableState.from || "",
      to: restoredTableState.to || "",
      category: restoredTableState.category || "",
      status: restoredTableState.status || "",
      onlyAzalea: Boolean(restoredTableState.onlyAzalea),
      employeeName: restoredTableState.employeeName || "",
    };

    setCurrentPage(restoredTableState.page || 1);
    setRowsPerPage(restoredTableState.size || 10);
    setAppliedFilters(restoredFilters);
    setDraftFilters(restoredFilters);
    setHasLoadedTableStatePage(false);
    setIsTableStateInitialized(true);
  }, [encryptedState, isTableStateInitialized, tableState]);

  useEffect(() => {
    if (!isTableStateInitialized) return;

    saveProductSubmissionTableState(currentTableState);
    navigateWithTableState("/product-submissions", currentTableState, {
      replace: true,
    });
  }, [currentTableState, isTableStateInitialized, navigateWithTableState]);

  useEffect(() => {
    if (!hasLoadedTableStatePage) return;
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [currentPage, hasLoadedTableStatePage, totalPages]);

  useEffect(() => {
    setSelectedRowIds((prev) => {
      const validIds = new Set(products.map((p) => String(p.id)));
      return prev.filter((id) => validIds.has(String(id)));
    });
  }, [products]);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      const actionElement = event.target?.closest(
        ".productSubmission-row-action",
      );
      const menuElement = event.target?.closest(
        ".productSubmission-actions-menu",
      );
      if (!actionElement && !menuElement) {
        setOpenActionMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, []);

  useEffect(() => {
    if (!isFilterOpen) return undefined;

    const handleOutsideFilterClick = (event) => {
      if (filterWrapRef.current?.contains(event.target)) return;
      setIsFilterOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideFilterClick);
    return () =>
      document.removeEventListener("mousedown", handleOutsideFilterClick);
  }, [isFilterOpen]);

  useEffect(() => {
    const onPopState = () => {
      setSelectedProduct(null);
      setLimitedInternalNotes("");
      setLastSavedNotes("");
      setCurrentPage(lastListPage);
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [lastListPage]);

  const goToNextPage = () => {
    setCurrentPage((p) => Math.min(p + 1, totalPages));
    setPageInputValue("");
    setIsPageInputFocused(false);
  };
  const goToPreviousPage = () => {
    setCurrentPage((p) => Math.max(p - 1, 1));
    setPageInputValue("");
    setIsPageInputFocused(false);
  };
  const goToTypedPage = (value = pageInputValue) => {
    const trimmedPageInput = String(value).trim();
    if (!trimmedPageInput) return false;

    const requestedPage = Number(trimmedPageInput);

    if (!Number.isInteger(requestedPage)) return false;

    const safePage = Math.min(Math.max(requestedPage, 1), totalPages);
    setCurrentPage(safePage);
    setPageInputValue("");
    setIsPageInputFocused(false);
    return true;
  };
  const getVisiblePaginationItems = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const items = [1];
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) items.push("...");
    for (let page = start; page <= end; page += 1) {
      items.push(page);
    }
    if (end < totalPages - 1) items.push("...");

    items.push(totalPages);
    
    return items;
  };

  const clearAllFilters = () => {
    const empty = {
      search: "",
      from: "",
      to: "",
      category: "",
      status: "",
      onlyAzalea: false,
      employeeName: "",
    };
    setDraftFilters(empty);
    setAppliedFilters(empty);
    setCurrentPage(1);
    setIsFilterOpen(false);
    setShowAllCategories(false);
  };

  const applyAllFilters = () => {
    setAppliedFilters(draftFilters);
    setCurrentPage(1);
    setIsFilterOpen(false);
    setShowAllCategories(false);
  };

  const normalizeDisplayDateInput = (value) => {
    const digitsOnly = String(value || "")
      .replace(/\D/g, "")
      .slice(0, 8);
    if (digitsOnly.length <= 2) return digitsOnly;
    if (digitsOnly.length <= 4)
      return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
    return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2, 4)}/${digitsOnly.slice(4)}`;
  };

  const formatApiDateToDisplay = (value) => {
    const normalized = String(value || "").trim();
    const yyyymmdd = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!yyyymmdd) return normalized;
    const [, yyyy, mm, dd] = yyyymmdd;
    return `${dd}/${mm}/${yyyy}`;
  };

  const toPickerDate = (value) => {
    const normalized = String(value || "").trim();
    const ddmmyyyy = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (ddmmyyyy) {
      const [, dd, mm, yyyy] = ddmmyyyy;
      return `${yyyy}-${mm}-${dd}`;
    }
    return normalized;
  };

  const openDatePicker = (inputRef) => {
    const input = inputRef?.current;
    if (!input) return;
    if (typeof input.showPicker === "function") return input.showPicker();
    input.focus();
    input.click();
  };

  const formatDateTimeLabel = (value) => {
    if (!value) return "-";
    const normalizedValue =
      typeof value === "string" ? value.replace(" ", "T") : value;
    const date = new Date(normalizedValue);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString("en-GB");
  };

  const formatDateOnlyLabel = (value) => {
    if (!value) return "-";
    const raw = String(value).trim();
    const yyyymmddOnly = raw.match(/^(\d{4}[-/]\d{2}[-/]\d{2})/);
    if (yyyymmddOnly) return yyyymmddOnly[1].replace(/-/g, "/");
    const ddmmyyyyOnly = raw.match(/^(\d{2}\/\d{2}\/\d{4})/);
    if (ddmmyyyyOnly) return ddmmyyyyOnly[1];

    const normalizedValue =
      typeof value === "string" ? value.replace(" ", "T") : value;
    const date = new Date(normalizedValue);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString("en-GB");
  };

  const normalizeStatus = (value) => {
    const normalized = String(value ?? "").trim();
    const normalizedUpper = normalized.toUpperCase();
    const statusMap = {
      0: "Pending",
      1: "Approved",
      2: "Rejected",
      3: "Resubmit",
      PENDING: "Pending",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      RESUBMIT: "Resubmit",
    };
    return statusMap[normalizedUpper] || statusMap[normalized] || "Pending";
  };

  const statusToApiValue = (value) => {
    const normalized = String(value || "")
      .trim()
      .toUpperCase();
    if (!normalized) return "";

    const map = {
      PENDING: "PENDING",
      APPROVED: "APPROVED",
      REJECTED: "REJECTED",
      RESUBMIT: "RESUBMIT",
    };

    return map[normalized] || "";
  };

  const formatCategoryLabel = (value) => {
    const normalized = String(value || "")
      .trim()
      .replace(/_/g, " ")
      .toLowerCase();
    if (!normalized) return "-";
    return normalized.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getCategoryDisplayLabel = (categoryName, categoryId) => {
    const exactName = String(categoryName || "").trim();
    if (exactName) return exactName;

    const fetchedName = getCategoryNameById(categoryId);
    if (fetchedName) return fetchedName;

    return formatCategoryLabel(categoryId);
  };

  const normalizeProductRow = (item, index) => {
    const source =
      item?.product ||
      item?.productDetails ||
      item?.productRequest ||
      item?.productDTO ||
      item;
    const skuEntity = Array.isArray(source?.skuEntity) ? source.skuEntity : [];
    const skus = Array.isArray(source?.skus) ? source.skus : [];
    const skuList = Array.isArray(source?.skuList) ? source.skuList : [];
    const firstSku = skuEntity[0] || skus[0] || skuList[0] || {};
    const productImages = Array.isArray(source?.productImages)
      ? source.productImages
      : Array.isArray(source?.images)
        ? source.images
        : Array.isArray(item?.images)
          ? item.images
          : [];
    const submittedByName =
      source?.submittedBy ||
      source?.employeeName ||
      source?.createdBy ||
      source?.createdByName ||
      source?.createdByID?.name ||
      source?.createdByID?.username ||
      item?.submittedBy ||
      item?.employeeName ||
      item?.createdBy ||
      item?.createdByName ||
      item?.createdByID?.name ||
      item?.createdByID?.username ||
      "-";
    const categoryId =
      source?.categoryId ||
      source?.basicInfo?.categoryId ||
      item?.categoryId ||
      item?.basicInfo?.categoryId ||
      "";
    const categoryName =
      source?.categoryName ||
      source?.basicInfo?.categoryName ||
      item?.categoryName ||
      item?.basicInfo?.categoryName ||
      source?.category ||
      source?.basicInfo?.category ||
      item?.category ||
      item?.basicInfo?.category ||
      "";

    const createdAtSource =
      source?.createdAt ||
      source?.submissionDate ||
      item?.createdAt ||
      item?.submissionDate ||
      "-";

    return {
      id:
        source?.productId ||
        source?.productID ||
        source?.id ||
        item?.productId ||
        item?.productID ||
        item?.id ||
        `product-${index}`,
      productId:
        source?.productId ||
        source?.productID ||
        item?.productId ||
        item?.productID,
      name:
        source?.productName ||
        source?.name ||
        source?.displayName ||
        source?.basicInfo?.productName ||
        item?.productName ||
        item?.name ||
        item?.displayName ||
        "-",
      sku:
        firstSku?.skuCode ||
        firstSku?.sku ||
        firstSku?.skuID ||
        firstSku?.skuId ||
        firstSku?.barcode ||
        source?.skuCode ||
        source?.skuID ||
        source?.skuId ||
        item?.skuCode ||
        item?.skuID ||
        item?.skuId ||
        "-",
      companyName: source?.companyName || item?.companyName || "-",
      submittedBy: submittedByName,
      dateCreated: formatDateOnlyLabel(createdAtSource),
      dateCreatedFull: formatDateTimeLabel(createdAtSource),
      category: getCategoryDisplayLabel(categoryName, categoryId),
      categoryId,
      images: `${productImages.length || 0} images`,
      status: normalizeStatus(
        source?.productCompanyStatus ||
          source?.productSystemStatus ||
          item?.productCompanyStatus ||
          item?.productSystemStatus,
      ),
      raw: {
        ...(source || item || {}),
        productImages,
      },
    };
  };

  const enrichRowsWithProductDetails = (rows, productsData) => {
    if (!Array.isArray(rows) || rows.length === 0) return rows;
    if (!Array.isArray(productsData) || productsData.length === 0) return rows;

    // Create a fast lookup by productID
    const productMap = new Map(
      productsData.map((item) => [item.productID, item]),
    );

    const enriched = rows.map((row) => {
      const hasName = String(row?.name || "").trim() && row?.name !== "-";
      const hasCategory =
        String(row?.category || "").trim() && row?.category !== "-";
      const hasSku = String(row?.sku || "").trim() && row?.sku !== "-";

      if (hasName && hasCategory && hasSku) return row;

      const raw = row?.raw || {};
      const productId =
        raw?.productId || raw?.productID || row?.productId || row?.id;

      if (!productId) return row;

      const product = productMap.get(productId);
      if (!product) return row;

      return {
        ...row,
        name: product?.productName || row?.name || "-",
        category: getCategoryDisplayLabel(
          product?.categoryName,
          product?.categoryId || row?.categoryId,
        ),
        categoryId: product?.categoryId || row?.categoryId || "",
        sku: product?.skuID || row?.sku || "-",
        raw: {
          ...(row?.raw || {}),
          ...product,
        },
      };
    });

    return enriched;
  };

  const toJavaTimestamp = (value) => {
    if (!value) return undefined;

    let d;

    if (value instanceof Date) {
      d = value;
    } else if (typeof value === "string" && value.includes("/")) {
      const [day, month, year] = value.split("/");

      d = new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      d = new Date(value);
    }

    if (Number.isNaN(d.getTime())) return undefined;

    const pad = (n) => String(n).padStart(2, "0");

    return (
      d.getFullYear() +
      "-" +
      pad(d.getMonth() + 1) +
      "-" +
      pad(d.getDate()) +
      " " +
      pad(d.getHours()) +
      ":" +
      pad(d.getMinutes()) +
      ":" +
      pad(d.getSeconds())
    );
  };

  const fetchProductRequests = async () => {
    if (!jwt) {
      setActionError("Missing authentication token.");
      setServerTotalElements(0);
      setServerTotalPages(1);
      setProducts([]);
      setHasLoadedTableStatePage(true);
      return;
    }

    const ProductRequestsDTO = {
      businessProfileID,
      categoryId: appliedFilters.category,
      companyId: appliedFilters.onlyAzalea ? userService.getCompID() : null,
     employeeName: appliedFilters.employeeName || "",
      companyName: "",
      fromDate: toJavaTimestamp(appliedFilters.from),
      page: Math.max(currentPage, 1),
      productCompanyStatus: statusToApiValue(appliedFilters.status),
      productName: "",
      productSystemStatus: statusToApiValue(appliedFilters.status),
      search: String(appliedFilters.search || "").trim(),
      size: rowsPerPage,
      toDate: toJavaTimestamp(appliedFilters.to),
    };

    try {
      setListLoading(true);
      setActionError("");
      const response = await ProductController.getProductRequests({
        ProductRequestsDTO,
        jwt,
      });
      setdisplayedRows(response.data.rows);
      const status = response?.status ?? response?.response?.status;
      const data = response?.data ?? response?.response?.data;
      setSummaryCounts({
  total: Number(data?.totalAll ?? data?.total ?? 0),
  pending: Number(data?.totalPending ?? 0),
  approved: Number(data?.totalApproved ?? 0),
});

      if (!(status >= 200 && status < 300) || !data) {
        throw new Error(
          getApiErrorMessage(response, "Failed to load product requests."),
        );
      }
setSummaryCounts({
  total: Number(data?.totalAll ?? 0),
  pending: Number(data?.totalPending ?? 0),
  approved: Number(data?.totalApproved ?? 0),
});
      const listSource =
        (Array.isArray(data?.content) && data?.content) ||
        (Array.isArray(data?.items) && data?.items) ||
        (Array.isArray(data?.list) && data?.list) ||
        (Array.isArray(data?.data) && data?.data) ||
        (Array.isArray(data?.products) && data?.products) ||
        (Array.isArray(data?.productRequests) && data?.productRequests) ||
        (Array.isArray(data?.rows) && data?.rows) ||
        (Array.isArray(data?.records) && data?.records) ||
        (Array.isArray(data?.result) && data?.result) ||
        (data &&
          typeof data === "object" &&
          Object.values(data).find((value) => Array.isArray(value))) ||
        [];
      const list = (
        Array.isArray(listSource) ? listSource : [listSource]
      ).filter(Boolean);
      const totalEl = Number(
        data?.totalElements ?? data?.total ?? data?.count ?? list.length ?? 0,
      );
      const totalPg = Number(
        data?.totalPages ??
          data?.pages ??
          Math.max(1, Math.ceil(totalEl / rowsPerPage)),
      );
      setServerTotalElements(Number.isFinite(totalEl) ? totalEl : list.length);
      setServerTotalPages(
        Number.isFinite(totalPg) && totalPg > 0 ? totalPg : 1,
      );
      const normalizedRows = list.map(normalizeProductRow);
      const rowsWithDetails = enrichRowsWithProductDetails(normalizedRows);
      setProducts(rowsWithDetails);
    } catch (err) {
      setActionError(
        getApiErrorMessage(err, "Failed to load product requests."),
      );
      setServerTotalElements(0);
      setServerTotalPages(1);
      setProducts([]);
    } finally {
      setHasLoadedTableStatePage(true);
      setListLoading(false);
    }
  };

  const getApiErrorMessage = (err, fallback) => {
    const payload = err?.response?.data ?? err?.data;
    const status = err?.response?.status ?? err?.status;
    if (status === 404) {
      return (
        payload?.message ||
        payload?.error ||
        "Resource not found (404). Verify companyId/productId and try again."
      );
    }
    if (typeof payload === "string" && payload.trim()) return payload;
    if (Array.isArray(payload?.errors) && payload.errors.length) {
      return payload.errors.join(", ");
    }
    return payload?.message || payload?.error || err?.message || fallback;
  };

  const getReviewerIdFromJwt = (targetCompanyId = companyID) => {
    const scopedCompanyId =
      targetCompanyId ||
      companyID ||
      Object.keys(parsedJwt?.userDetails || {})[0];
    const companyScoped = parsedJwt?.userDetails?.[scopedCompanyId];
    return (
      parsedJwt?.userID ||
      parsedJwt?.userId ||
      parsedJwt?.id ||
      companyScoped?.employeeId ||
      companyScoped?.employeeID ||
      parsedJwt?.employeeID ||
      parsedJwt?.employeeId ||
      ""
    );
  };

  const normalizeQrCodeStatus = (value, fallback = "PENDING") => {
    const allowed = new Set(["PENDING", "ACTIVE", "EMPTY", "EXPIRED"]);
    const normalized = String(value || "")
      .trim()
      .toUpperCase();
    if (allowed.has(normalized)) return normalized;

    const fallbackNormalized = String(fallback || "PENDING")
      .trim()
      .toUpperCase();
    return allowed.has(fallbackNormalized) ? fallbackNormalized : "PENDING";
  };

  const formatDimensionsValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "string" || typeof value === "number") {
      return String(value);
    }
    if (typeof value === "object") {
      const unit =
        value?.unitOfDimensions || value?.unit || value?.measureUnit || "";
      const parts = [value?.length, value?.width, value?.height].filter(
        (v) => v !== null && v !== undefined && v !== "",
      );
      if (parts.length) {
        return `${parts.join(" x ")}${unit ? ` ${unit}` : ""}`;
      }
      return JSON.stringify(value);
    }
    return String(value);
  };

  const formatRenderableValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return formatDimensionsValue(value);
    return String(value);
  };

  const formatWeightValue = (value, unit) => {
    if (value === null || value === undefined || value === "") return "-";
    const normalizedUnit = String(unit || "").trim();
    return `${value}${normalizedUnit ? ` ${normalizedUnit}` : ""}`;
  };

  const mapProductStatusToQrStatus = (statusValue) => {
    const normalized = String(statusValue || "")
      .trim()
      .toUpperCase();
    if (normalized === "APPROVED") return "ACTIVE";
    if (normalized === "REJECTED") return "EMPTY";
    return "PENDING";
  };

  const normalizeDetailsResponse = (details) => {
    if (!details || typeof details !== "object") return {};

    const activityLog = details?.activityLog || {};
    const skuSource = Array.isArray(details?.skus)
      ? details.skus
      : Array.isArray(details?.skuEntity)
        ? details.skuEntity
        : Array.isArray(details?.skuList)
          ? details.skuList
          : [];
    const normalizedSkus = skuSource.map((sku) => ({
      ...(sku || {}),
      skuID: sku?.skuID ?? sku?.skuId ?? sku?.id ?? "",
      sku: sku?.sku ?? sku?.skuCode ?? sku?.skuID ?? sku?.skuId ?? "-",
      size: sku?.size ?? sku?.sizeType ?? "-",
      material: sku?.material ?? sku?.skuMaterial ?? "-",
      color: sku?.color ?? sku?.skuColor ?? "-",
      stockQuantity:
        sku?.stockQuantity ?? sku?.qty ?? sku?.quantity ?? sku?.stock ?? "-",
      unitOfMeasure:
        sku?.unitOfMeasure ?? sku?.uom ?? sku?.measureUnit ?? sku?.unit ?? "-",
      barcode: sku?.barcode ?? sku?.barCode ?? "-",
      dimensions: (() => {
        const joined = [sku?.length, sku?.width, sku?.height]
          .filter(Boolean)
          .join(" x ");
        return formatDimensionsValue(sku?.dimensions ?? joined ?? "-");
      })(),
      technicalSpecifications:
        sku?.technicalSpecifications ?? sku?.technicalSpec ?? sku?.specs ?? "-",
    }));

    return {
      ...details,
      productId: details?.productId ?? details?.productID ?? "",
      productDetailsID:
        details?.productDetailsID ?? details?.productDetailsId ?? null,
      internalNotes: details?.internalNotes ?? details?.internalNote ?? "",
      submissionDate: details?.submissionDate ?? details?.submittedDate ?? "",
      submittedBy: details?.submittedBy ?? details?.employeeName,
      basicInfo: {
        ...(details?.basicInfo || {}),
        productName:
          details?.basicInfo?.productName ||
          details?.productName ||
          details?.productTitle ||
          "",
      },
      activityLog: {
        ...activityLog,
        assignedAt: activityLog?.assignedAt || activityLog?.assginedAt || "",
      },
      skus: normalizedSkus,
    };
  };
  const [displayedProd, setDisplayedProd] = useState([]);

  const openProductView = async (product) => {
    setLastListPage(currentPage);
    setSelectedProduct(product);
    const initialNotes = String(
      product?.raw?.internalNotes ?? product?.raw?.notes ?? "",
    );
    setLimitedInternalNotes(initialNotes);
    setLastSavedNotes(limitInternalNotes(initialNotes));

    setActionError("");
    setOpenActionMenuId(null);

    window.history.pushState(
      { productView: true, tableState: currentTableState },
      "",
    );
    const raw = product?.raw || {};
    const productId = raw?.productId || raw?.productID || product?.productId;
    const requestCompanyId =
      raw?.companyId || raw?.companyID || companyID || "";

    if (!jwt || !productId || !requestCompanyId) return;

    try {
      const response = await ProductController.getProductDetails({
        productRequest: {
          businessProfileID,
          companyId: requestCompanyId,
          productId,
        },
        Authorization: jwt,
      });
      if (response) {
        setDisplayedProd(response.data);
      }
      assertControllerSuccess(response, "Failed to load product details.");
      const detailsResponse = response?.data ?? response?.response?.data;
      const details =
        detailsResponse?.product ||
        detailsResponse?.productDetails ||
        detailsResponse?.data ||
        detailsResponse;

      if (details && typeof details === "object") {
        const normalizedDetails = normalizeDetailsResponse(details);
        const mergedRaw = {
          ...raw,
          ...normalizedDetails,
          productId:
            normalizedDetails?.productId ||
            raw?.productId ||
            raw?.productID ||
            null,
          productDetailsID:
            normalizedDetails?.productDetailsID ||
            raw?.productDetailsID ||
            raw?.productDetailsId ||
            null,
          submittedBy:
            normalizedDetails?.submittedBy ||
            raw?.submittedBy ||
            raw?.employeeName ||
            "-",
        };
        setSelectedProduct((prev) =>
          prev && prev.id === product.id
            ? {
                ...prev,
                productId:
                  mergedRaw?.productId ||
                  prev?.productId ||
                  prev?.raw?.productId ||
                  prev?.raw?.productID,
                raw: mergedRaw,
              }
            : prev,
            
        );


        const nextNotes = String(
          mergedRaw?.internalNotes ?? mergedRaw?.notes ?? "",
        );
        setLimitedInternalNotes(nextNotes);
        setLastSavedNotes(limitInternalNotes(nextNotes));
      }
    } catch (e) {
      setActionError(getApiErrorMessage(e, "Failed to load product details."));
    }
  };

  const toggleRowActionMenu = (productId, event) => {
    const triggerRect = event?.currentTarget?.getBoundingClientRect?.();
    if (!triggerRect) {
      setOpenActionMenuId((prev) => (prev === productId ? null : productId));
      return;
    }

    setActionMenuPosition({
      top: Math.round(triggerRect.top + 8),
      left: Math.round(triggerRect.left - 183),
    });
    setOpenActionMenuId((prev) => (prev === productId ? null : productId));
  };

  const handleDownloadFromActions = (product) => {
    const fileName = String(product?.name || "product")
      .trim()
      .replace(/\s+/g, "-")
      .toLowerCase();
    const anchor = document.createElement("a");
    anchor.href = productPic;
    anchor.download = `${fileName || "product"}-image.svg`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setOpenActionMenuId(null);
  };

  const handlePrintFromActions = (product) => {
    setOpenActionMenuId(null);
    openPrintConfigForProduct(product);
  };

  const toggleRowSelection = (productId, checked) => {
    const normalizedId = String(productId);
    setSelectedRowIds((prev) => {
      if (checked) {
        return prev.includes(normalizedId) ? prev : [...prev, normalizedId];
      }
      return prev.filter((id) => id !== normalizedId);
    });
  };

  const handleSelectAllCurrentRows = (checked) => {
    if (!checked) {
      setSelectedRowIds((prev) =>
        prev.filter((id) => !currentRowIds.includes(String(id))),
      );
      return;
    }
    setSelectedRowIds((prev) => {
      const merged = new Set([...prev, ...currentRowIds]);
      return Array.from(merged);
    });
  };

  const AddProductImage = async (productId, files) => {
    const selectedFiles = Array.from(files || []);
    if (!productId || !selectedFiles.length) return;

    try {
      setImageAdding(true);
      setActionError("");

      const catalogResponse = await ProductController.getProductCatalogDetails({
        Authorization: userService.getUser(),
        productRequest: {
          businessProfileID: userService.getBPID(),
          companyId: userService.getCompID(),
          productId,
        },
      });
      assertControllerSuccess(
        catalogResponse,
        "Failed to load product catalog details.",
      );

      const catalogDetails =
        catalogResponse?.data ?? catalogResponse?.response?.data;
      const catalogSkus = Array.isArray(catalogDetails?.skus)
        ? catalogDetails.skus
        : [];
      if (!catalogSkus.length) {
        throw new Error(
          "This product does not have a SKU to attach images to.",
        );
      }

      const loadedDetails =
        activeProduct?.details ||
        (ProductDetails && typeof ProductDetails === "object"
          ? ProductDetails
          : {});
      const loadedSkus = Array.isArray(loadedDetails?.skus)
        ? loadedDetails.skus
        : [];
      const findLoadedSku = (catalogSku) =>
        loadedSkus.find(
          (loadedSku) =>
            String(loadedSku?.skuID || loadedSku?.skuId || "") ===
            String(catalogSku?.skuID || catalogSku?.skuId || ""),
        ) || {};
      const resolvedCountryOfProduction =
        catalogDetails?.basicInfo?.countryOfProduction ??
        loadedDetails?.basicInfo?.countryOfProduction ??
        parsedJwt?.countryName ??
        parsedJwt?.country ??
        "";
      const resolveDimensions = (...dimensionsList) => {
        const dimensions = dimensionsList.find(
          (item) => item && typeof item === "object",
        );

        return {
          height: dimensions?.height,
          length: dimensions?.length,
          unitOfDimensions: dimensions?.unitOfDimensions,
          width: dimensions?.width,
        };
      };

      const processedImages = await Promise.all(
        selectedFiles.map((file) => Utils.processImageFile(file)),
      );
      const newImageAttachments = processedImages.map((image, index) => {
        const file = selectedFiles[index];
        return {
          attachmentStatus: "DEFAULT",
          attachmentType: "PRODUCT_IMAGE",
          countryName: resolvedCountryOfProduction,
          customPath: "",
          data: Utils.padBase64(image.base64),
          extension: String(file?.name || "")
            .split(".")
            .pop()
            .toLowerCase(),
          objectName: file?.name || image.name,
          userName:
            parsedJwt?.username || parsedJwt?.sub || parsedJwt?.name || "",
        };
      });

      const targetSkuId =
        getCurrentImage()?.skuId ||
        activeProduct?.skuId ||
        activeProduct?.details?.skus?.[0]?.skuID ||
        activeProduct?.details?.skus?.[0]?.skuId;
      const targetSkuIndex = Math.max(
        0,
        catalogSkus.findIndex(
          (sku) =>
            String(sku?.skuID || sku?.skuId || "") ===
            String(targetSkuId || ""),
        ),
      );

      const productRequestDto = {
        basicInfo: {
          brand: catalogDetails?.basicInfo?.brand,
          category: catalogDetails?.basicInfo?.category,
          categoryId:
            catalogDetails?.basicInfo?.categoryId ??
            loadedDetails?.basicInfo?.categoryId,
          categoryName:
            catalogDetails?.basicInfo?.categoryName ??
            loadedDetails?.basicInfo?.categoryName,
          countryOfProduction: resolvedCountryOfProduction,
          deliveryMethod:
            catalogDetails?.basicInfo?.deliveryMethod ??
            loadedDetails?.basicInfo?.deliveryMethod,
          description: catalogDetails?.basicInfo?.description,
          productName: catalogDetails?.basicInfo?.productName,
          subCategoryId:
            catalogDetails?.basicInfo?.subCategoryId ??
            loadedDetails?.basicInfo?.subCategoryId,
          subCategoryName:
            catalogDetails?.basicInfo?.subCategoryName ??
            loadedDetails?.basicInfo?.subCategoryName,
        },
        companyId: catalogDetails?.companyId || userService.getCompID(),
        skus: catalogSkus.map((sku, skuIndex) => {
          const loadedSku = findLoadedSku(sku);
          const existingVideos = Array.isArray(sku?.productVideos)
            ? sku.productVideos
            : Array.isArray(loadedSku?.productVideos)
              ? loadedSku.productVideos
              : [];

          return {
            azaleaBarcode: sku?.azaleaBarcode ?? loadedSku?.azaleaBarcode,
            barcode: sku?.barcode ?? loadedSku?.barcode,
            colorInfo: Array.isArray(sku?.colorInfo)
              ? sku.colorInfo
              : Array.isArray(loadedSku?.colorInfo)
                ? loadedSku.colorInfo
                : [],
            costPriceValue:
              sku?.costPriceValue ??
              loadedSku?.costPriceValue ??
              catalogDetails?.pricingAndProfit?.costPrice,
            currency: sku?.currency ?? loadedSku?.currency,
            dimensions: resolveDimensions(
              sku?.dimensions,
              loadedSku?.dimensions,
              sku?.productDimensions,
              loadedSku?.productDimensions,
              sku?.packageDimensions,
              loadedSku?.packageDimensions,
            ),
            initialStockQuantity:
              sku?.initialStockQuantity ?? loadedSku?.initialStockQuantity,
            material: sku?.material ?? loadedSku?.material,
            model: sku?.model ?? loadedSku?.model,
            packageDimensions: resolveDimensions(
              sku?.packageDimensions,
              loadedSku?.packageDimensions,
            ),
            packageWeight: sku?.packageWeight ?? loadedSku?.packageWeight,
            packageWeightUnitOfMeasure:
              sku?.packageWeightUnitOfMeasure ??
              loadedSku?.packageWeightUnitOfMeasure,
            price:
              sku?.price ??
              loadedSku?.price ??
              catalogDetails?.pricingAndProfit?.defaultBasePrice,
            productDimensions: resolveDimensions(
              sku?.productDimensions,
              loadedSku?.productDimensions,
            ),
            productImages:
              skuIndex === targetSkuIndex ? newImageAttachments : [],
            productVideos: existingVideos,
            productWeight: sku?.productWeight ?? loadedSku?.productWeight,
            productWeightUnitOfMeasure:
              sku?.productWeightUnitOfMeasure ??
              loadedSku?.productWeightUnitOfMeasure,
            reservedStockQuantity:
              sku?.reservedStockQuantity ?? loadedSku?.reservedStockQuantity,
            size: sku?.size ?? loadedSku?.size,
            skuCode: sku?.skuCode ?? loadedSku?.skuCode,
            skuID:
              sku?.skuID || sku?.skuId || loadedSku?.skuID || loadedSku?.skuId,
            stockQuantity: sku?.stockQuantity ?? loadedSku?.stockQuantity,
            technicalSpecs: sku?.technicalSpecs ?? loadedSku?.technicalSpecs,
            unitOfMeasure: sku?.unitOfMeasure ?? loadedSku?.unitOfMeasure,
          };
        }),
        userId: Utils.getUserIdFromJwt(jwt) || getReviewerIdFromJwt(),
        videoUrls: Array.isArray(catalogDetails?.videoUrls)
          ? catalogDetails.videoUrls
          : [],
      };

      const updateResponse = await ProductController.updateProduct({
        Authorization: userService.getUser(),
        productId,
        productRequestDto,
      });
      assertControllerSuccess(updateResponse, "Failed to add product images.");
      await handleProductDetail(activeProduct);
    } catch (error) {
      setActionError(
        getApiErrorMessage(error, "Failed to add product images."),
      );
    } finally {
      setImageAdding(false);
    }
  };

  const handleProductImageSelection = async (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    await AddProductImage(activeProduct?.productId || activeProduct?.id, files);
  };

  const getScopedRows = () => {
    if (exportScope === "FILTERED") return filteredProducts;
    if (exportScope === "SELECTED") {
      const selectedSet = new Set(selectedRowIds.map(String));
      return products.filter((row) => selectedSet.has(String(row.id)));
    }
    return products;
  };

  const buildDelimitedContent = (rows, delimiter = ",") => {
    const header = [
      "Product Name",
      "SKU",
      "Submitted By",
      "Date Created",
      "Category",
      "Status",
    ];
    const escapeCell = (value) =>
      `"${String(value ?? "").replace(/"/g, '""')}"`;
    const lines = rows.map((row) =>
      [
        row?.name,
        row?.sku,
        row?.submittedBy,
        row?.dateCreated,
        row?.category,
        row?.status,
      ]
        .map(escapeCell)
        .join(delimiter),
    );
    return [header.map(escapeCell).join(delimiter), ...lines].join("\n");
  };

  const triggerFileDownload = (content, fileName, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  };

  const handleExportAction = () => {
    const scopedRows = getScopedRows();
    if (exportScope === "SELECTED" && scopedRows.length === 0) {
      setActionError("No selected rows to export.");
      return;
    }
    setActionError("");

    if (exportFormat === "PRINT") {
      setIsExportModalOpen(false);
      setIsPrintConfigOpen(true);
      return;
    }

    if (exportFormat === "PDF") {
      setIsExportModalOpen(false);
      window.print();
      return;
    }

    const delimiter = exportFormat === "EXCEL" ? "\t" : ",";
    const ext = exportFormat === "EXCEL" ? "xls" : "csv";
    const mimeType =
      exportFormat === "EXCEL"
        ? "application/vnd.ms-excel;charset=utf-8;"
        : "text/csv;charset=utf-8;";
    const content = buildDelimitedContent(scopedRows, delimiter);
    triggerFileDownload(
      content,
      `product-submissions-${String(exportScope).toLowerCase()}.${ext}`,
      mimeType,
    );
    setIsExportModalOpen(false);
  };

  const handleProceedPrint = () => {
    const rowsToPrint = getScopedRows();
    if (!rowsToPrint.length) {
      setActionError("No rows available for printing.");
      return;
    }

    const sizeMm = getPrintSizeMm(printSize);
    Promise.all(
      rowsToPrint.map(async (row) => ({
        qrSrc: await Utils.base64ToQRCode(String(resolvePrintValue(row))),
        row,
      })),
    )
      .then((printRows) => {
        const printWindow = window.open("", "_blank", "width=900,height=700");
        if (!printWindow) {
          setActionError(
            "Pop-up was blocked. Please allow pop-ups and try again.",
          );
          return;
        }
        const cardsHtml = printRows
          .map(
            ({ qrSrc, row }) => `
              <div class="print-card">
                <img src="${qrSrc}" alt="QR code" class="print-qr" />
                <div class="print-name">${row?.name || "Product"}</div>
                <div class="print-sku">${row?.sku || "-"}</div>
              </div>`,
          )
          .join("");

        printWindow.document.write(`
          <html>
            <head>
              <title>Product QR Print</title>
              <style>
                body { font-family: Arial, sans-serif; margin: 24px; }
                .print-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(${Math.max(
                  sizeMm * 4,
                  140,
                )}px, 1fr)); gap: 18px; }
                .print-card { border: 1px solid #d0d5dd; border-radius: 10px; padding: 14px; display: flex; flex-direction: column; align-items: center; gap: 10px; }
                .print-qr { width: ${sizeMm}mm; height: ${sizeMm}mm; object-fit: contain; }
                .print-name { font-size: 14px; font-weight: 600; text-align: center; }
                .print-sku { font-size: 12px; color: #667085; text-align: center; }
                @media print { body { margin: 10mm; } }
              </style>
            </head>
            <body>
              <div class="print-grid">${cardsHtml}</div>
            </body>
          </html>`);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
        setIsPrintConfigOpen(false);
      })
      .catch((error) => {
        setActionError(
          getApiErrorMessage(error, "Failed to prepare print preview."),
        );
      });
  };

  const openExportPrintModal = () => {
    setExportFormat("PDF");
    setExportScope(selectedRowIds.length ? "SELECTED" : "ALL");
    setIsExportModalOpen(true);
  };

  const openPrintConfigForProduct = (product) => {
    setSelectedRowIds(product?.id ? [String(product.id)] : []);
    setExportScope("SELECTED");
    setExportFormat("PRINT");
    setIsPrintConfigOpen(true);
  };

  const handleDeleteFromActions = (productId) => {
    setProducts((prev) => prev.filter((p) => p.id !== productId));
    setOpenActionMenuId(null);
  };

  const DeleteProduct = async (productId) => {
    const request = {
      companyId: userService.getCompID(),
      forceDelete: true,
      productId: productId,
    };
    try {
      const response = await ProductController.deleteProduct({
        request: request,
        Authorization: userService.getUser(),
      });
      if (response?.status >= 200 && response?.status < 300) {
        setProducts((prev) => prev.filter((p) => p.id !== productId));
      }
    } catch (error) {}
  };

  const handleDeleteSelectedProducts = async () => {
    const idsToDelete = Array.from(new Set(selectedRowIds.map(String))).filter(
      Boolean,
    );

    if (!idsToDelete.length || bulkDeleteLoading) return;

    try {
      setBulkDeleteLoading(true);
      setActionError("");
      setOpenActionMenuId(null);

      const results = await Promise.allSettled(
        idsToDelete.map(async (productId) => {
          const response = await ProductController.deleteProduct({
            request: {
              companyId: userService.getCompID(),
              forceDelete: true,
              productId,
            },
            Authorization: userService.getUser(),
          });
          const status = response?.status ?? response?.response?.status;

          if (!(status >= 200 && status < 300)) {
            throw response;
          }

          return response;
        }),
      );

      const failedDeletes = results.filter(
        (result) => result.status === "rejected",
      );

      if (failedDeletes.length) {
        throw failedDeletes[0].reason;
      }

      // window.location.reload();
    } catch (error) {
      setActionError(
        getApiErrorMessage(error, "Failed to delete selected products."),
      );
    } finally {
      setBulkDeleteLoading(false);
    }
  };

  useEffect(() => {
    if (!isTableStateInitialized) return;

    fetchProductRequests();
  }, [
    jwt,
    appliedFilters,
    currentPage,
    rowsPerPage,
    isTableStateInitialized,
  ]);

  const closeProductView = () => {
    if (window.history.state?.productView) {
      window.history.back();
      return;
    }
    setSelectedProduct(null);
    setLimitedInternalNotes("");
    setLastSavedNotes("");
    setCurrentPage(lastListPage);
  };

  const getSelectedProductContext = () => {
    const raw = selectedProduct?.raw || {};
    const productId =
      raw?.productId || raw?.productID || selectedProduct?.productId;
    const productDetailsID =
      raw?.productDetailsID || raw?.productDetailsId || raw?.detailsId || "";
    const targetCompanyId = raw?.companyId || raw?.companyID || companyID || "";

    if (!selectedProduct) throw new Error("No product selected.");
    if (!productId) throw new Error("Missing product ID in selected product.");
    if (!targetCompanyId)
      throw new Error("Missing company ID for selected product.");

    return { raw, productId, productDetailsID, targetCompanyId };
  };

  const saveInternalNotes = async () => {
    if (!selectedProduct) return;

    const notesValue = String(internalNotes || "").trim();
    const previousValue = String(lastSavedNotes || "").trim();
    if (notesValue === previousValue) return;
    let raw;
    let productId;
    let productDetailsID;
    let targetCompanyId;
    try {
      ({ raw, productId, productDetailsID, targetCompanyId } =
        getSelectedProductContext());
    } catch (e) {
      setActionError(getApiErrorMessage(e, "Update product details failed."));
      return;
    }

    const statusForUpdate = String(
      raw?.productCompanyStatus ||
        raw?.productSystemStatus ||
        selectedProduct?.status ||
        "PENDING",
    ).toUpperCase();
    const normalizedNotesValue = notesValue || "";
    const reviewerId = getReviewerIdFromJwt(targetCompanyId);
    const qrCodeStatus = normalizeQrCodeStatus(
      raw?.qrCodeStatus,
      mapProductStatusToQrStatus(statusForUpdate),
    );

    try {
      setNotesSaving(true);
      setActionError("");

      if (jwt && productId) {
        const productDetailsRequest = {
          businessProfileID: userService.getBPID(),
          companyId: targetCompanyId,
          internalNotes: normalizedNotesValue,
          productCompanyStatus: statusForUpdate,
          productDetailsID: productDetailsID || null,
          productId,
          productSystemStatus: statusForUpdate,
          qrCodeStatus: "ACTIVE",
          rejectionReason: String(rejectReason || "").trim() || null,
          reviewerId: String(reviewerId),
        };

        const response = await ProductController.addupdateproductdetails({
          productDetailsRequest,
          jwt,
        });
        assertControllerSuccess(response, "Update product details failed.");
      }

      setProducts((prev) =>
        prev.map((p) =>
          p.id === selectedProduct.id
            ? {
                ...p,
                raw: {
                  ...(p.raw || {}),
                  internalNotes: notesValue,
                  notes: notesValue,
                },
              }
            : p,
        ),
      );

      setSelectedProduct((prev) =>
        prev
          ? {
              ...prev,
              raw: {
                ...(prev.raw || {}),
                internalNotes: notesValue,
                notes: notesValue,
              },
            }
          : prev,
      );

      setLastSavedNotes(notesValue);
    } catch (e) {
      setActionError(getApiErrorMessage(e, "Update product details failed."));
    } finally {
      setNotesSaving(false);
    }
  };

  const syncProductStatusLocal = (nextStatus) => {
    const normalized =
      String(nextStatus || "")
        .charAt(0)
        .toUpperCase() +
      String(nextStatus || "")
        .slice(1)
        .toLowerCase();
    const normalizedUpper = String(nextStatus || "PENDING").toUpperCase();

    setProducts((prev) =>
      prev.map((p) =>
        p.id === selectedProduct?.id
          ? {
              ...p,
              status: normalized,
              raw: {
                ...(p.raw || {}),
                status: nextStatus,
                productCompanyStatus: normalizedUpper,
                productSystemStatus: normalizedUpper,
              },
            }
          : p,
      ),
    );

    setSelectedProduct((prev) =>
      prev
        ? {
            ...prev,
            status: normalized,
            raw: {
              ...(prev.raw || {}),
              status: nextStatus,
              productCompanyStatus: normalizedUpper,
              productSystemStatus: normalizedUpper,
            },
          }
        : prev,
    );
  };

  const persistProductStatus = async (nextStatus) => {
    if (!jwt) throw new Error("Missing authentication token.");
    const { raw, productId, productDetailsID, targetCompanyId } =
      getSelectedProductContext();
    const reviewerId = getReviewerIdFromJwt(targetCompanyId);
    const requestedStatus = String(nextStatus || "PENDING").toUpperCase();
    const statusForUpdate = requestedStatus;
    const qrCodeStatus = normalizeQrCodeStatus(
      raw?.qrCodeStatus,
      mapProductStatusToQrStatus(statusForUpdate),
    );
    const rejectionOrResubmitReason =
      requestedStatus === "RESUBMIT"
        ? String(resubmitReason || "").trim()
        : String(rejectReason || "").trim();
    const normalizedInternalNotes =
      String(internalNotes || raw?.internalNotes || "").trim() || "";
    const normalizedRejectionReason = rejectionOrResubmitReason || null;

    const productDetailsRequest = {
      businessProfileID: userService.getBPID(),
      companyId: targetCompanyId,
      internalNotes: normalizedInternalNotes,
      productCompanyStatus: statusForUpdate,
      productDetailsID: productDetailsID || null,
      productId,
      productSystemStatus: statusForUpdate,
      qrCodeStatus: "ACTIVE",
      rejectionReason: normalizedRejectionReason,
      reviewerId: String(reviewerId),
    };

    const response = await ProductController.addupdateproductdetails({
      productDetailsRequest,
      jwt,
    });
    assertControllerSuccess(response, "Update product status failed.");
  };

  const buildProductEmailPayload = ({
    messageToApplicant,
    productCompanyStatus,
    productSystemStatus = "APPROVED",
  }) => {
    const raw = selectedProduct?.raw || {};
    const targetCompanyId =
      raw?.companyId || selectedProduct?.companyId || companyID || "";
    const scopedEmployeeId = getReviewerIdFromJwt(targetCompanyId);

    return {
      employeeID: String(
        parsedJwt?.userID ||
          parsedJwt?.userId ||
          parsedJwt?.id ||
          scopedEmployeeId ||
          parsedJwt?.employeeID ||
          parsedJwt?.employeeId ||
          "",
      ),
      messageToApplicant,
      productCompanyStatus,
      productId:
        raw?.productId ||
        raw?.productID ||
        selectedProduct?.productId ||
        selectedProduct?.id ||
        "",
      productName:
        raw?.productName || raw?.displayName || selectedProduct?.name || "",
      productSystemStatus: String(
        productSystemStatus ||
          raw?.productSystemStatus ||
          raw?.productCompanyStatus ||
          selectedProduct?.status ||
          "APPROVED",
      ).toUpperCase(),
      submittedBy: String(
        raw?.employeeID ||
          raw?.employeeId ||
          raw?.submittedById ||
          raw?.submittedByID ||
          selectedProduct?.employeeID ||
          selectedProduct?.employeeId ||
          "",
      ),
      url: window?.location?.origin || "",
    };
  };

  const assertControllerSuccess = (response, fallbackMessage) => {
    const status = response?.status ?? response?.response?.status;
    if (status && status >= 200 && status < 300) return;

    const backendMessage =
      response?.data?.message ||
      response?.data?.error ||
      response?.response?.data?.message ||
      response?.response?.data?.error ||
      fallbackMessage;

    throw new Error(backendMessage);
  };

  const handleConfirmResubmission = async () => {
    if (!resubmitReason.trim()) return;

    try {
      setActionLoading(true);
      setActionError("");
      await persistProductStatus("RESUBMIT");

      if (notifySubmitter) {
        const response = await ProductController.sendResubmissionEmail({
          productEmail: buildProductEmailPayload({
            messageToApplicant: resubmitReason.trim(),
            productCompanyStatus: "RESUBMIT",
            productSystemStatus: "RESUBMIT",
          }),
          jwt,
        });
        assertControllerSuccess(response, "Resubmission email failed.");
      }

      syncProductStatusLocal("Resubmit");
      saveInternalNotes();
      setIsResubmitPopupOpen(false);
      setResubmitReason("");
      setNotifySubmitter(true);
    } catch (e) {
      setActionError(getApiErrorMessage(e, "Resubmission failed."));
    } finally {
      setActionLoading(false);
    }
  };

  const handleConfirmApproval = async () => {
    try {
      setActionLoading(true);
      setActionError("");

      if (approveNotifySubmitter) {
        const response = await ProductController.sendApprovedEmail({
          productEmail: buildProductEmailPayload({
            messageToApplicant:
              String(approveNotes || "").trim() ||
              "Your product submission has been approved.",
            productCompanyStatus: "APPROVED",
            productSystemStatus: "APPROVED",
          }),
          jwt,
        });
        saveInternalNotes();
        assertControllerSuccess(response, "Approval email failed.");
      }
      await persistProductStatus("APPROVED");

      syncProductStatusLocal("Approved");

      setIsApproveOpen(false);
      setApproveNotes("");
      setApproveNotifySubmitter(true);
    } catch (e) {
      setActionError(getApiErrorMessage(e, "Approval failed."));
    } finally {
      setActionLoading(false);
    }
  };

  const handleConfirmRejection = async () => {
    if (!rejectReason.trim()) {
      setRejectValidationError(
        "You must provide a rejection reason before confirming.",
      );
      return;
    }

    try {
      setActionLoading(true);
      setActionError("");
      await persistProductStatus("REJECTED");

      if (notifyRejectSubmitter) {
        const response = await ProductController.sendRejectedEmail({
          productEmail: buildProductEmailPayload({
            messageToApplicant: rejectReason.trim(),
            productCompanyStatus: "REJECTED",
            productSystemStatus: "REJECTED",
          }),
          jwt,
        });
        assertControllerSuccess(response, "Rejection email failed.");
      }

      syncProductStatusLocal("Rejected");
      saveInternalNotes();
      setIsRejectOpen(false);
      setRejectReason("");
      setNotifyRejectSubmitter(true);
      setRejectValidationError("");
    } catch (e) {
      setActionError(getApiErrorMessage(e, "Rejection failed."));
    } finally {
      setActionLoading(false);
    }
  };

  const openResubmitPopup = () => setIsResubmitPopupOpen(true);
  const closeResubmitPopup = () => setIsResubmitPopupOpen(false);

  const openApprovePopup = () => {
    setApproveNotes("");
    setApproveNotifySubmitter(true);
    setIsApproveOpen(true);
  };

  const openRejectPopup = () => {
    setRejectReason("");
    setNotifyRejectSubmitter(true);
    setRejectValidationError("");
    setIsRejectOpen(true);
  };

  const closeRejectPopup = () => {
    setIsRejectOpen(false);
    setRejectReason("");
    setNotifyRejectSubmitter(true);
    setRejectValidationError("");
  };

  const detailBadgeClass = (statusValue) => {
    const normalized = String(statusValue || "").toLowerCase();
    if (normalized === "approved")
      return "productSubmission-status productSubmission-status-approved";
    if (normalized === "pending")
      return "productSubmission-status productSubmission-status-pending";
    if (normalized === "rejected")
      return "productSubmission-status productSubmission-status-rejected";
    return "productSubmission-status";
  };

  // Details
  const rawDetails = selectedProduct?.raw || {};
  const activityLog = rawDetails?.activityLog || {};
  const reviewerName =
    activityLog?.reviewerName ||
    rawDetails?.reviewerName ||
    rawDetails?.assignedReviewer ||
    rawDetails?.reviewer ||
    "Unassigned";
  const assignedOn =
    activityLog?.assignedAt ||
    activityLog?.assginedAt ||
    rawDetails?.assignedOn ||
    rawDetails?.submittedDate ||
    rawDetails?.submissionDate ||
    rawDetails?.createdAt ||
    null;
  const lastActivity =
    activityLog?.lastActivity ||
    rawDetails?.updatedAt ||
    rawDetails?.submittedDate ||
    rawDetails?.submissionDate ||
    null;

  const changeHistory = (
    Array.isArray(rawDetails?.activityLogs) ? rawDetails.activityLogs : []
  )
    .slice()
    .sort((a, b) =>
      String(b?.performedAt || "").localeCompare(String(a?.performedAt || "")),
    );

  const formatHistoryChange = (change) =>
    change?.field === "reviewerId" && activityLog?.reviewerName
      ? `reviewerName: ${activityLog.reviewerName}`
      : `${change?.field ? `${change.field}: ` : ""}${formatRenderableValue(change?.oldValue)} → ${formatRenderableValue(change?.newValue)}`;

  const submittedDateTime =
    rawDetails?.submissionDate ||
    rawDetails?.createdAt ||
    selectedProduct?.dateCreatedFull ||
    selectedProduct?.dateCreated ||
    "-";

  const productImagesRaw = Array.isArray(rawDetails?.productImages)
    ? rawDetails.productImages
    : Array.isArray(rawDetails?.images)
      ? rawDetails.images
      : [];
  const productImageSources = productImagesRaw
    .map((img) => {
      if (typeof img === "string") return img;
      if (!img || typeof img !== "object") return "";
      return (
        img?.url ||
        img?.imageUrl ||
        img?.imageURL ||
        img?.path ||
        img?.s3Url ||
        img?.s3URL ||
        ""
      );
    })
    .filter(Boolean);
  const resolvedProductImageSources =
    productImageSources.length > 0 ? productImageSources : [];

  const basicInfo = rawDetails?.basicInfo || {};
  const skuEntries = Array.isArray(rawDetails?.skus)
    ? rawDetails.skus
    : Array.isArray(rawDetails?.skuEntity)
      ? rawDetails.skuEntity
      : Array.isArray(rawDetails?.skuList)
        ? rawDetails.skuList
        : [];
  const scopedRows = getScopedRows();
  const exportRecordCount = scopedRows.length;
  const printSizeLabel =
    printSizeOptions.find((opt) => opt.key === printSize)?.size ||
    "20mm x 20mm";
  const exportActionLabel = {
    PDF: "Export as PDF",
    CSV: "Export as CSV",
    EXCEL: "Export as Excel",
    PRINT: `Print ${exportRecordCount} products`,
  }[exportFormat];
  const getMediaUrl = (media) => {
    if (typeof media === "string") return media;
    if (!media || typeof media !== "object") return "";
    return (
      media?.data ||
      media?.url ||
      media?.imageUrl ||
      media?.imageURL ||
      media?.path ||
      media?.s3Url ||
      media?.s3URL ||
      media?.customPath ||
      ""
    );
  };
  const getMediaKind = (media) => {
    const explicitType = String(media?.attachmentType || media?.type || "")
      .trim()
      .toUpperCase();
    if (explicitType.includes("VIDEO")) return "video";
    const extension = String(media?.extension || "")
      .trim()
      .toLowerCase();
    if (["mp4", "webm", "mov", "m4v", "avi"].includes(extension))
      return "video";
    const url = getMediaUrl(media).toLowerCase();
    if (/\.(mp4|webm|mov|m4v|avi)(\?|$)/.test(url)) return "video";
    return "image";
  };
  const getPrimarySku = (details) => {
    if (!details) return null;
    if (Array.isArray(details?.skus) && details.skus.length)
      return details.skus[0];
    if (Array.isArray(details?.skuEntity) && details.skuEntity.length)
      return details.skuEntity[0];
    if (Array.isArray(details?.skuList) && details.skuList.length)
      return details.skuList[0];
    return null;
  };
  const getSkuIdentifier = (sku) => sku?.skuID || sku?.skuId || sku?.id || "";
  const getAllSkuAttachments = (details) => {
    const skus = Array.isArray(details?.skus)
      ? details.skus
      : Array.isArray(details?.skuEntity)
        ? details.skuEntity
        : Array.isArray(details?.skuList)
          ? details.skuList
          : [];

    return skus.flatMap((sku, skuIndex) => {
      const skuId = getSkuIdentifier(sku);
      const skuCode = sku?.skuCode || sku?.sku || skuId;
      const decorateMedia = (media) => ({
        ...media,
        skuId,
        skuCode,
        skuIndex,
      });
      const images = Array.isArray(sku?.productImages)
        ? sku.productImages.filter((image) => getMediaUrl(image))
        : [];
      const videos = Array.isArray(sku?.productVideos)
        ? sku.productVideos.filter((video) => getMediaUrl(video))
        : [];

      return [...images, ...videos].map(decorateMedia);
    });
  };
  const getPrintSizeMm = (sizeKey) =>
    ({
      SMALL: 20,
      MEDIUM: 40,
      LARGE: 80,
      XLARGE: 120,
    })[sizeKey] || 20;
  const getCurrentImage = () => activeImages?.[currentIndex] || null;
  const getCurrentImageAttachmentId = () => {
    const image = getCurrentImage();
    return (
      image?.attachmentID ||
      image?.attachmentId ||
      image?.attachment_id ||
      image?.id ||
      null
    );
  };
  const resolvePrintValue = (row) => {
    const raw = row?.raw || {};
    return (
      raw?.qrCodes?.[0]?.codeValue ||
      raw?.qrCode?.codeValue ||
      row?.productId ||
      row?.id ||
      row?.sku ||
      row?.name ||
      "AZALEA"
    );
  };
  const handleRangeChange = ({ from, to }) => {
    setDraftFilters((prev) => ({
      ...prev,
      from: from || "",
      to: to || "",
    }));
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? activeImages.length - 1 : prev - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === activeImages.length - 1 ? 0 : prev + 1,
    );
  };
  useEffect(() => {
    setCurrentIndex(0);
  }, [activeImages]);

  const readAiJobCache = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(AI_JOB_CACHE_KEY) || "{}");
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      return {};
    }
  };

  const writeAiJobCache = (nextValue) => {
    try {
      localStorage.setItem(AI_JOB_CACHE_KEY, JSON.stringify(nextValue));
    } catch (error) {}
  };

  const mergeAiJobs = (incomingJobs) => {
    if (!Array.isArray(incomingJobs) || !incomingJobs.length) return;

    setAiJobs((prev) => {
      const next = { ...(prev || {}) };
      incomingJobs.forEach((job) => {
        const productId = String(job?.productId || "");
        const jobId = String(job?.jobId || "");
        if (!productId || !jobId) return;
        const existing = Array.isArray(next[productId]) ? next[productId] : [];
        const filtered = existing.filter(
          (entry) => String(entry?.jobId || "") !== jobId,
        );
        next[productId] = [job, ...filtered].slice(0, 30);
      });
      writeAiJobCache(next);
      return next;
    });
  };

  const loadProductAiJobs = async (productId) => {
    if (!productId) return [];
    try {
      const response = await ProductController.getProductAiJobs({
        Authorization: userService.getUser(),
        productId,
      });
      assertControllerSuccess(response, "Failed to load AI jobs.");
      const jobs = response?.data ?? response?.response?.data ?? [];
      mergeAiJobs(jobs);
      return jobs;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    const cachedJobs = readAiJobCache();
    setAiJobs(cachedJobs);
  }, []);

  useEffect(() => {
    let active = true;
    if (!isPrintConfigOpen) {
      setPrintPreviewSrc("");
      return undefined;
    }
    const previewRow =
      getScopedRows()[0] || selectedProduct || currentRows?.[0];
    if (!previewRow) {
      setPrintPreviewSrc("");
      return undefined;
    }
    Utils.base64ToQRCode(String(resolvePrintValue(previewRow)))
      .then((qrSrc) => {
        if (active) setPrintPreviewSrc(qrSrc);
      })
      .catch(() => {
        if (active) setPrintPreviewSrc("");
      });
    return () => {
      active = false;
    };
  }, [
    isPrintConfigOpen,
    printSize,
    exportScope,
    selectedRowIds,
    products,
    selectedProduct,
    currentPage,
  ]);

  useEffect(() => {
    if (isResubmitPopupOpen || isRejectOpen || isApproveOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isResubmitPopupOpen, isRejectOpen, isApproveOpen]);

  useEffect(() => {
    if (!AIInhancment) return;
    const productIds = selectedProduct?.id
      ? [selectedProduct.id]
      : Array.from(new Set(selectedRowIds.map(String)));
    productIds.filter(Boolean).forEach((productId) => {
      loadProductAiJobs(productId);
    });
  }, [AIInhancment, selectedProduct?.id, selectedRowIds]);

  useEffect(() => {
    if (!openImagePopup || !activeProduct?.id) return;
    loadProductAiJobs(activeProduct.id);
  }, [openImagePopup, activeProduct?.id]);

  const getJobsForProduct = (productId) =>
    Array.isArray(aiJobs?.[String(productId || "")])
      ? aiJobs[String(productId || "")]
      : [];

  const isPendingAiJob = (job) =>
    !!job &&
    !job?.done &&
    ["QUEUED", "IN_PROGRESS"].includes(String(job?.status || ""));

  const formatAiJobTypeLabel = (jobType) =>
    String(jobType || "")
      .toLowerCase()
      .split("_")
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");

  const getJobSummaryForProduct = (productId, jobType) => {
    const jobs = getJobsForProduct(productId).filter(
      (job) => String(job?.jobType || "") === String(jobType || ""),
    );
    if (!jobs.length) return "";
    const inProgress = jobs.find(
      (job) =>
        !job?.done &&
        ["QUEUED", "IN_PROGRESS"].includes(String(job?.status || "")),
    );
    if (inProgress) {
      return `${Math.max(0, Number(inProgress?.progressPercent || 0))}% generating`;
    }
    const latest = jobs[0];
    if (String(latest?.status || "") === "FAILED") return "Last job failed";
    if (String(latest?.status || "") === "COMPLETED") return "Ready";
    return "";
  };

  const latestPhotoEnhancementJob = React.useMemo(() => {
    const productId =
      activeProduct?.id || selectedProduct?.id || selectedRowIds?.[0];
    return getJobsForProduct(productId).find(
      (job) => String(job?.jobType || "") === "PHOTO_ENHANCEMENT",
    );
  }, [activeProduct?.id, selectedProduct?.id, selectedRowIds, aiJobs]);
  const activePendingAiJobs = React.useMemo(() => {
    const productId =
      activeProduct?.id || selectedProduct?.id || selectedRowIds?.[0];
    return getJobsForProduct(productId).filter((job) => isPendingAiJob(job));
  }, [activeProduct?.id, selectedProduct?.id, selectedRowIds, aiJobs]);
  const activePendingAiJob = activePendingAiJobs[0] || null;
  const activeAiJobMessage =
    activePendingAiJob?.message ||
    latestPhotoEnhancementJob?.message ||
    "Enhancing your image...";

  const applySelectedAiEnhancements = async () => {
    const productIds = selectedProduct?.id
      ? [selectedProduct.id]
      : Array.from(new Set(selectedRowIds.map(String)));
    if (!photoEnhance && !videoEnhance && !docEnhance) {
      setActionError(
        "Please enable at least one AI setting before generating.",
      );
      return;
    }
    if (!productIds.length) {
      setActionError("Please select at least one product first.");
      return;
    }
    try {
      setActionError("");
      const results = await Promise.allSettled(
        productIds.map(async (productId) => {
          const productDetails = await fetchProductDetailsById(productId);
          const queued = [];
          if (photoEnhance) {
            queued.push(await queueDimensionJobForProduct(productDetails));
          }
          if (videoEnhance) {
            queued.push(await queueVideoJobForProduct(productDetails));
          }
          if (docEnhance) {
            queued.push(await queueDescriptionJobForProduct(productDetails));
          }
          return queued;
        }),
      );
      const failedProductIds = results
        .map((result, index) =>
          result.status === "rejected" ? productIds[index] : null,
        )
        .filter(Boolean);
      if (failedProductIds.length) {
        setActionError(
          `Some AI jobs could not be queued for: ${failedProductIds.join(", ")}`,
        );
      }
    } catch (error) {
      setActionError(getApiErrorMessage(error, "Failed to queue AI jobs."));
    }
  };

  const handleProductDetail = async (product, focusAttachmentId = null) => {
    const productRequest = {
      businessProfileID: userService.getBPID(),
      companyId:
        product?.raw?.companyId ||
        product?.raw?.companyID ||
        userService.getCompID(),
      productId:
        product?.productId ||
        product?.raw?.productId ||
        product?.raw?.productID,
    };

    try {
      const getProductDetails = await ProductController.getProductDetails({
        Authorization: userService.getUser(),
        productRequest: productRequest,
      });
      if (
        (getProductDetails?.status ?? getProductDetails?.response?.status) ==
        200
      ) {
        const payload =
          getProductDetails?.data ?? getProductDetails?.response?.data;
        const normalized = normalizeDetailsResponse(payload);
        const primarySku = getPrimarySku(normalized);
        const attachments = getAllSkuAttachments(normalized);
        seProductDetails(normalized);
        setActiveProduct({
          ...product,
          productId: normalized?.productId || product?.productId || product?.id,
          details: normalized,
          skuId:
            attachments[0]?.skuId ||
            primarySku?.skuID ||
            primarySku?.skuId ||
            "",
          name:
            normalized?.basicInfo?.productName ||
            product?.name ||
            "Product Images",
        });
        setActiveImages(attachments);
        setReplaceOriginal(false);
        const targetIndex = focusAttachmentId
          ? Math.max(
              0,
              attachments.findIndex(
                (image) =>
                  String(
                    image?.attachmentID ||
                      image?.attachmentId ||
                      image?.attachment_id ||
                      "",
                  ) === String(focusAttachmentId),
              ),
            )
          : 0;
        setCurrentIndex(targetIndex);
        setOpenImagePopup(true);
      }
    } catch (error) {
      setActionError(
        getApiErrorMessage(
          error,
          "Failed to load product images for enhancement.",
        ),
      );
    }
  };

  const buildEnhanceImageRequest = async (image) => {
    const details = ProductDetails || activeProduct?.details || {};
    const primarySku = getPrimarySku(details);
    const imageUrl = getMediaUrl(image);
    const dataUrl = await Utils.imageUrlToBase64(imageUrl);
    const base64Parts = getBase64Parts(dataUrl);

    if (!base64Parts?.base64 || base64Parts.base64 === "string") {
      throw new Error("Failed to prepare image for AI enhancement.");
    }

    return {
      createdById: Utils.getUserIdFromJwt(jwt),
      existingAttachmentId:
        image?.attachmentID ||
        image?.attachmentId ||
        image?.attachment_id ||
        null,
      imageBase64: base64Parts.base64,
      imageMimeType:
        base64Parts.mimeType !== "string" &&
        base64Parts.mimeType !== "application/octet-stream"
          ? base64Parts.mimeType
          : getImageMimeType(image),
      images: [
        {
          imageBase64: base64Parts.base64,
          label: image?.objectName || image?.label || "product-image",
          mimeType:
            base64Parts.mimeType !== "string" &&
            base64Parts.mimeType !== "application/octet-stream"
              ? base64Parts.mimeType
              : getImageMimeType(image),
        },
      ],
      objectName:
        image?.objectName ||
        details?.basicInfo?.productName ||
        activeProduct?.name ||
        "product-image",
      productId:
        details?.productId ||
        activeProduct?.productId ||
        activeProduct?.id ||
        null,
      productName: details?.basicInfo?.productName || activeProduct?.name || "",
      prompt:
        "Improve the product image for ecommerce use with cleaner lighting, sharper edges, accurate colors, and better clarity while preserving the real product shape and materials.",
      quality: "high",
      replaceOriginal,
      size: "1024x1024",
      skuId:
        image?.skuId ||
        primarySku?.skuID ||
        primarySku?.skuId ||
        activeProduct?.skuId ||
        null,
      userName:
        parsedJwt?.username ||
        parsedJwt?.sub ||
        activeProduct?.submittedBy ||
        "system",
    };
  };

  const handleEnhanceActiveImage = async () => {
    const currentImage = getCurrentImage();
    if (!currentImage) return;
    if (getMediaKind(currentImage) !== "image") {
      setActionError(
        "Image enhancement can only be applied to image attachments.",
      );
      return;
    }
    try {
      setImageEnhancing(true);
      setActionError("");
      const details = ProductDetails || activeProduct?.details || {};
      const hasSelectedSettings = photoEnhance || videoEnhance || docEnhance;
      if (!hasSelectedSettings) {
        const request = await buildEnhanceImageRequest(currentImage);
        await queueAiJob({
          start: ProductController.startEnhanceProductImageJob,
          request,
        });
      } else if (photoEnhance) {
        await queueDimensionJobForProduct(details);
      }
      if (videoEnhance) {
        await queueVideoJobForProduct(details);
      }
      if (docEnhance) {
        await queueDescriptionJobForProduct(details);
      }
    } catch (error) {
      setActionError(getApiErrorMessage(error, "AI image enhancement failed."));
    } finally {
      setImageEnhancing(false);
    }
  };

  const handleEnhanceAllActiveImages = async () => {
    if (!Array.isArray(activeImages) || !activeImages.length) return;
    try {
      setImageEnhancing(true);
      setActionError("");
      const details = ProductDetails || activeProduct?.details || {};
      const hasSelectedSettings = photoEnhance || videoEnhance || docEnhance;
      const imageAttachments = activeImages.filter(
        (image) => getMediaKind(image) === "image",
      );
      if (!hasSelectedSettings) {
        for (const image of imageAttachments) {
          const request = await buildEnhanceImageRequest(image);
          await queueAiJob({
            start: ProductController.startEnhanceProductImageJob,
            request,
          });
        }
      } else if (photoEnhance) {
        await queueDimensionJobForProduct(details);
      }
      if (videoEnhance) {
        await queueVideoJobForProduct(details);
      }
      if (docEnhance) {
        await queueDescriptionJobForProduct(details);
      }
    } catch (error) {
      setActionError(getApiErrorMessage(error, "AI image enhancement failed."));
    } finally {
      setImageEnhancing(false);
    }
  };

  const handleDeleteActiveImage = async () => {
    const attachmentId = getCurrentImageAttachmentId();
    if (!attachmentId) {
      setActionError(
        "The selected image cannot be deleted because no attachment ID was found.",
      );
      return;
    }
    try {
      setImageDeleting(true);
      setActionError("");
      const details = ProductDetails || activeProduct?.details || {};
      const currentImage = getCurrentImage();
      const primarySku = getPrimarySku(details);
      const response = await ProductController.deleteProductAttachment({
        Authorization: userService.getUser(),
        request: {
          attachmentId,
          productId:
            details?.productId ||
            activeProduct?.productId ||
            activeProduct?.id ||
            null,
          skuId:
            currentImage?.skuId ||
            primarySku?.skuID ||
            primarySku?.skuId ||
            activeProduct?.skuId ||
            null,
        },
      });
      assertControllerSuccess(response, "Failed to delete product image.");
      await handleProductDetail(activeProduct);
    } catch (error) {
      setActionError(
        getApiErrorMessage(error, "Failed to delete product image."),
      );
    } finally {
      setImageDeleting(false);
    }
  };

  const fetchProductDetailsById = async (productId) => {
    const productRequest = {
      businessProfileID: userService.getBPID(),
      companyId: userService.getCompID(),
      productId,
    };

    const response = await ProductController.getProductDetails({
      Authorization: userService.getUser(),
      productRequest,
    });

    return response?.data ?? response?.response?.data ?? null;
  };

  const queueAiJob = async ({ start, request, successMessage }) => {
    const response = await start({
      Authorization: userService.getUser(),
      request,
    });
    assertControllerSuccess(response, "Failed to queue AI job.");
    const job = response?.data ?? response?.response?.data;
    if (!job?.jobId) {
      throw new Error("The AI job did not return a job ID.");
    }
    mergeAiJobs([job]);
    if (successMessage) {
      setActionError(successMessage);
    }
    return job;
  };
  const AddVideoToProduct = async () => {
    const productRequestDto = {
      basicInfo: {
        brand: displayedProd?.basicInfo?.brand,
        category: displayedProd?.basicInfo?.category,
        categoryId: displayedProd?.basicInfo?.categoryId,
        countryOfProduction: displayedProd?.basicInfo?.countryOfProduction,
        description: displayedProd?.basicInfo?.description,
        model: displayedProd?.basicInfo?.model,
        productName: displayedProd?.basicInfo?.productName,
      },
      companyId: displayedProd?.basicInfo?.categoryId,
      skus: [
        {
          barcode: displayedProd?.skus?.[0]?.barcode,
          colorInfo: displayedProd?.skus?.[0]?.colorInfo,
          costPriceValue: displayedProd?.skus?.[0]?.costPriceValue,
          currency: displayedProd?.skus?.[0]?.currency,
          dimensions: {
            height: displayedProd?.skus?.[0]?.dimensions?.height,
            length: displayedProd?.skus?.[0]?.dimensions?.length,
            unitOfDimensions:
              displayedProd?.skus?.[0]?.dimensions?.unitOfDimensions,
            width: displayedProd?.skus?.[0]?.dimensions?.width,
          },
          initialStockQuantity: displayedProd?.skus?.[0]?.initialStockQuantity,
          material: displayedProd?.skus?.[0]?.material,
          price: displayedProd?.skus?.[0]?.price,
          productImages: displayedProd?.skus?.[0]?.productImages,
          productVideos: [
            ...(displayedProd?.skus?.[0]?.productVideos || []),
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "PRODUCT_VIDEO",
              countryName: displayedProd?.basicInfo?.countryOfProduction,
              customPath: "string",
              data: (await Utils.processVideoFile(videoFile)).base64,
              extension: videoFile.name.split(".").pop().toLowerCase(),
              objectName: videoFile.name,
              userName: Utils.parseJwt(userService.getUser()).username,
            },
          ],
          reservedStockQuantity:
            displayedProd?.skus?.[0]?.reservedStockQuantity,
          size: displayedProd?.skus?.[0]?.size,
          skuCode: displayedProd?.skus?.[0]?.skuCode,
          skuID: displayedProd?.skus?.[0]?.skuID,
          stockQuantity: displayedProd?.skus?.[0]?.stockQuantity,
          technicalSpecs: displayedProd?.skus?.[0]?.technicalSpecs,
          unitOfMeasure: displayedProd?.skus?.[0]?.unitOfMeasure,
        },
      ],
      userId: "377899800-e89b-12d3-a456-426614174000",
      videoUrls: [videoUrl],
    };
    try {
      const updateProduct = await ProductController.updateProduct({
        Authorization: userService.getUser(),
        productId: selectedProduct.id,
        productRequestDto: productRequestDto,
      });
    } catch (error) {}
  };

  const getUrlExtension = (url) => {
    const cleanUrl = String(url || "").split("?")[0];
    const lastDot = cleanUrl.lastIndexOf(".");
    return lastDot === -1 ? "" : cleanUrl.slice(lastDot + 1).toLowerCase();
  };

  const getImageMimeType = (image) => {
    const extension =
      image?.extension || getUrlExtension(image?.data || image || "");
    if (extension === "jpg" || extension === "jpeg") return "image/jpeg";
    if (extension === "png") return "image/png";
    if (extension === "webp") return "image/webp";
    return "string";
  };

  const getBase64Parts = (dataUrl) => {
    if (!dataUrl) return null;

    const match = String(dataUrl).match(/^data:(.*?);base64,(.*)$/);
    if (!match) return { base64: dataUrl, mimeType: "string" };

    return {
      base64: match[2],
      mimeType: match[1] || "string",
    };
  };

  const normalizeAIVideoImage = (image) => {
    if (!image) return null;
    if (typeof image === "string") return { data: image };
    return image;
  };

  const getAIVideoImages = (productDetails, sku) => {
    const skuImages = Array.isArray(sku?.productImages)
      ? sku.productImages
      : [];

    return skuImages.map(normalizeAIVideoImage).filter((image, index, list) => {
      const imageUrl = image?.data || image?.url || image?.customPath;
      return (
        imageUrl &&
        list.findIndex(
          (item) => (item?.data || item?.url || item?.customPath) === imageUrl,
        ) === index
      );
    });
  };

  const buildAIVideoRequest = async (productDetails) => {
    const sku = productDetails?.skus?.[0] || {};
    const basicInfo = productDetails?.basicInfo || {};
    const images = getAIVideoImages(productDetails, sku);

    if (!images.length) {
      throw new Error(
        `No product images found for product ${productDetails?.productId || ""}`,
      );
    }

    const mappedImages = await Promise.all(
      images.map(async (image, index) => {
        const imageUrl = image?.data || image?.url || image?.customPath;
        const dataUrl = await Utils.imageUrlToBase64(imageUrl);
        const base64Parts = getBase64Parts(dataUrl);

        if (!base64Parts?.base64 || base64Parts.base64 === "string") {
          throw new Error(`Failed to convert image URL to base64: ${imageUrl}`);
        }

        return {
          imageBase64: base64Parts.base64,
          label:
            image?.objectName ||
            image?.label ||
            `${basicInfo?.productName || productDetails?.productName || "product"}-${index + 1}`,
          mimeType:
            base64Parts.mimeType !== "string" &&
            base64Parts.mimeType !== "application/octet-stream"
              ? base64Parts.mimeType
              : getImageMimeType(image),
          // sourceUrl: image?.data,
        };
      }),
    );
    return {
      aspectRatio: "16:9",
      createdById: Utils.getUserIdFromJwt(jwt),
      durationSeconds: 6,
      generateAudio: false,
      images: mappedImages,
      negativePrompt: "blurry, distorted, watermark, text, wrong colors",
      productId:
        productDetails?.productId || productDetails?.productID || "string",
      prompt:
        "Create a clean ecommerce product video with smooth camera motion and accurate product details.",
      resolution: "720p",
      sampleCount: 1,
      skuId: sku?.skuID || sku?.skuId || "string",
      productName:
        basicInfo?.productName || productDetails?.productName || "product",
      skuCode: sku?.skuCode || "",
    };
  };

  const buildSkuDescriptionJobRequest = (productDetails) => {
    const sku = getPrimarySku(productDetails) || {};
    const basicInfo = productDetails?.basicInfo || {};
    return {
      productId:
        productDetails?.productId ||
        productDetails?.productID ||
        productDetails?.id ||
        null,
      skuId: sku?.skuID || sku?.skuId || null,
      createdById: Utils.getUserIdFromJwt(jwt),
      brand: basicInfo?.brand,
      category: basicInfo?.category,
      currentDescription: basicInfo?.description,
      language: "en",
      maxWords: 200,
      model: basicInfo?.model,
      productName: basicInfo?.productName,
      sku: {
        barcode: sku?.barcode,
        colorInfo: sku?.colorInfo,
        costPriceValue: sku?.costPriceValue,
        currency: sku?.currency,
        dimensions: {
          height: sku?.dimensions?.height,
          length: sku?.dimensions?.length,
          unitOfDimensions: sku?.dimensions?.unitOfDimensions,
          width: sku?.dimensions?.width,
        },
        initialStockQuantity: sku?.initialStockQuantity,
        material: sku?.material,
        price: sku?.price,
        productImages: sku?.productImages,
        productVideos: sku?.productVideos,
        reservedStockQuantity: sku?.reservedStockQuantity,
        size: sku?.size,
        skuCode: sku?.skuCode,
        skuID: sku?.skuID,
        stockQuantity: sku?.stockQuantity,
        technicalSpecs: sku?.technicalSpecs,
        unitOfMeasure: sku?.unitOfMeasure,
      },
      tone: "professional",
    };
  };

  const buildSkuDimensionJobRequest = async (productDetails) => {
    const sku = getPrimarySku(productDetails) || {};
    const firstImage = Array.isArray(sku?.productImages)
      ? sku.productImages[0]
      : null;
    if (!firstImage) {
      throw new Error(`No product images found for SKU ${sku?.skuCode || ""}`);
    }
    const imageUrl =
      firstImage?.data || firstImage?.url || firstImage?.customPath;
    const dataUrl = await Utils.imageUrlToBase64(imageUrl);
    const base64Parts = getBase64Parts(dataUrl);
    if (!base64Parts?.base64 || base64Parts.base64 === "string") {
      throw new Error(`Failed to convert image for SKU ${sku?.skuCode || ""}`);
    }

    return {
      productId:
        productDetails?.productId ||
        productDetails?.productID ||
        productDetails?.id ||
        null,
      skuId: sku?.skuID || sku?.skuId || null,
      createdById: Utils.getUserIdFromJwt(jwt),
      productName:
        productDetails?.basicInfo?.productName ||
        productDetails?.name ||
        "product",
      skuCode: sku?.skuCode || "",
      imageBase64: base64Parts.base64,
      mimeType:
        base64Parts.mimeType !== "string" &&
        base64Parts.mimeType !== "application/octet-stream"
          ? base64Parts.mimeType
          : getImageMimeType(firstImage),
      images: [
        {
          imageBase64: base64Parts.base64,
          label:
            firstImage?.objectName || firstImage?.label || "dimension-source",
          mimeType:
            base64Parts.mimeType !== "string" &&
            base64Parts.mimeType !== "application/octet-stream"
              ? base64Parts.mimeType
              : getImageMimeType(firstImage),
        },
      ],
      dimensions: {
        height: sku?.dimensions?.height,
        length: sku?.dimensions?.length,
        unitOfDimensions: sku?.dimensions?.unitOfDimensions,
        width: sku?.dimensions?.width,
      },
      includeImageBase64: false,
      objectName: `${productDetails?.basicInfo?.productName || "product"}-${sku?.skuCode || "sku"}-dimensions`,
    };
  };

  const queueVideoJobForProduct = async (productDetails) => {
    const request = await buildAIVideoRequest(productDetails);

    return queueAiJob({
      start: ProductController.startGenerateVideoFromPhotosJob,
      request,
    });
  };

  const queueDescriptionJobForProduct = async (productDetails) => {
    const request = buildSkuDescriptionJobRequest(productDetails);
    return queueAiJob({
      start: ProductController.startGenerateSkuDescriptionJob,
      request,
    });
  };

  const queueDimensionJobForProduct = async (productDetails) => {
    const request = await buildSkuDimensionJobRequest(productDetails);
    return queueAiJob({
      start: ProductController.startGenerateSkuDimensionImageJob,
      request,
    });
  };

  const CreateAIVideosForSelectedProducts = async (
    productIdsOverride = null,
  ) => {
    const productIds = Array.from(
      new Set((productIdsOverride || selectedRowIds).map(String)),
    );
    if (!productIds.length) return [];
    const results = await Promise.allSettled(
      productIds.map(async (productId) => {
        const productDetails = await fetchProductDetailsById(productId);
        return queueVideoJobForProduct(productDetails);
      }),
    );
    const failedProductIds = results
      .map((result, index) =>
        result.status === "rejected" ? productIds[index] : null,
      )
      .filter(Boolean);
    if (failedProductIds.length) {
      setActionError(
        `Failed to queue video generation for: ${failedProductIds.join(", ")}`,
      );
    }
    return results;
  };

  const HandlegenerateSkuDescription = async (productIdsOverride = null) => {
    const productIds = Array.from(
      new Set((productIdsOverride || selectedRowIds).map(String)),
    );
    if (!productIds.length) return;
    const results = await Promise.allSettled(
      productIds.map(async (productId) => {
        const productDetails = await fetchProductDetailsById(productId);
        return queueDescriptionJobForProduct(productDetails);
      }),
    );
    const failedProductIds = results
      .map((result, index) =>
        result.status === "rejected" ? productIds[index] : null,
      )
      .filter(Boolean);
    if (failedProductIds.length) {
      setActionError(
        `Failed to queue description generation for: ${failedProductIds.join(", ")}`,
      );
    }
  };

  const HandlegenerateSkuDimensionImage = async (productIdsOverride = null) => {
    const productIds = Array.from(
      new Set((productIdsOverride || selectedRowIds).map(String)),
    );
    if (!productIds.length) return;
    const results = await Promise.allSettled(
      productIds.map(async (productId) => {
        const productDetails = await fetchProductDetailsById(productId);
        return queueDimensionJobForProduct(productDetails);
      }),
    );
    const failedProductIds = results
      .map((result, index) =>
        result.status === "rejected" ? productIds[index] : null,
      )
      .filter(Boolean);
    if (failedProductIds.length) {
      setActionError(
        `Failed to queue dimension image generation for: ${failedProductIds.join(", ")}`,
      );
    }
  };
  return (
    <div
      className={`productSubmission-main-container ${selectedProduct ? "productSubmission-main-container-view" : ""}`}
    >
      {BulkProds ? (
        <div className="productSubmission-bulk-import-overlay">
          <div className="productSubmission-bulk-import-modal">
            <div className="productSubmission-bulk-import-header">
              <div className="productSubmission-bulk-import-title">
                Bulk Product Import
              </div>
              <button
                type="button"
                className="productSubmission-bulk-import-close"
                onClick={closeBulkImportPopup}
                disabled={bulkImportLoading}
                aria-label="Close bulk product import"
              >
                <XIcon />
              </button>
            </div>

            <div className="productSubmission-bulk-import-body">
              <label
                className={`productSubmission-bulk-import-upload ${
                  bulkImportLoading ? "disabled" : ""
                }`}
              >
                <input
                  type="file"
                  accept=".csv,text/csv"
                  onChange={handleBulkImportFileChange}
                  disabled={bulkImportLoading}
                />
                <span>Upload CSV</span>
              </label>

              {bulkImportFile ? (
                <div className="productSubmission-bulk-import-file-name">
                  Selected file: {bulkImportFile.name}
                </div>
              ) : null}

              <div
                className="productSubmission-bulk-import-toggle"
                role="radiogroup"
                aria-label="Bulk product import mode"
              >
                <button
                  type="button"
                  className={`productSubmission-bulk-import-toggle-option ${
                    validateOnly ? "active" : ""
                  }`}
                  onClick={() => setValidateOnly(true)}
                  disabled={bulkImportLoading}
                  role="radio"
                  aria-checked={validateOnly}
                >
                  Validate Only
                </button>
                <button
                  type="button"
                  className={`productSubmission-bulk-import-toggle-option ${
                    !validateOnly ? "active" : ""
                  }`}
                  onClick={() => setValidateOnly(false)}
                  disabled={bulkImportLoading}
                  role="radio"
                  aria-checked={!validateOnly}
                >
                  Import
                </button>
              </div>

              {bulkImportMessage || bulkImportResult ? (
                <div
                  className={`productSubmission-bulk-import-message ${
                    bulkImportMessageType === "error" ? "error" : "success"
                  }`}
                >
                  {bulkImportMessage ? (
                    <div className="productSubmission-bulk-import-message-text">
                      {bulkImportMessage}
                    </div>
                  ) : null}

                  {bulkImportResult ? (
                    <div className="productSubmission-bulk-import-result">
                      <div className="productSubmission-bulk-import-summary">
                        <div className="productSubmission-bulk-import-summary-item">
                          <span>Mode</span>
                          <strong>
                            {bulkImportResult.validateOnly
                              ? "Validate Only"
                              : "Import"}
                          </strong>
                        </div>
                        <div className="productSubmission-bulk-import-summary-item">
                          <span>Total Rows</span>
                          <strong>{bulkImportResult.totalRows ?? 0}</strong>
                        </div>
                        <div className="productSubmission-bulk-import-summary-item">
                          <span>Products</span>
                          <strong>
                            {bulkImportResult.productsDetected ?? 0}
                          </strong>
                        </div>
                        <div className="productSubmission-bulk-import-summary-item">
                          <span>Imported Products</span>
                          <strong>
                            {bulkImportResult.importedProducts ?? 0}
                          </strong>
                        </div>
                        <div className="productSubmission-bulk-import-summary-item">
                          <span>Imported SKUs</span>
                          <strong>{bulkImportResult.importedSkus ?? 0}</strong>
                        </div>
                        <div className="productSubmission-bulk-import-summary-item">
                          <span>Failed Rows</span>
                          <strong>{bulkImportResult.failedRows ?? 0}</strong>
                        </div>
                      </div>

                      {Array.isArray(bulkImportResult.products) &&
                      bulkImportResult.products.length ? (
                        <div className="productSubmission-bulk-import-products">
                          <div className="productSubmission-bulk-import-products-header">
                            Products
                          </div>
                          {bulkImportResult.products.map((product, index) => (
                            <div
                              className="productSubmission-bulk-import-product-row"
                              key={`${product.rowNumber || "row"}-${index}`}
                            >
                              <div className="productSubmission-bulk-import-product-main">
                                <span>
                                  Row {product.rowNumber ?? index + 1}
                                </span>
                                <strong>{product.productName || "-"}</strong>
                              </div>
                              <div className="productSubmission-bulk-import-product-meta">
                                <span>{product.skuCount ?? 0} SKUs</span>
                                <span
                                  className={`productSubmission-bulk-import-product-status ${String(
                                    product.status || "",
                                  ).toLowerCase()}`}
                                >
                                  {product.status || "-"}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}

                      {Array.isArray(bulkImportResult.errors) &&
                      bulkImportResult.errors.length ? (
                        <div className="productSubmission-bulk-import-errors">
                          <div className="productSubmission-bulk-import-products-header">
                            Errors
                          </div>
                          {bulkImportResult.errors.map((error, index) => (
                            <div
                              className="productSubmission-bulk-import-error-row"
                              key={`bulk-import-error-${index}`}
                            >
                              {getBulkImportErrorText(error)}
                            </div>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>

            <div className="productSubmission-bulk-import-footer">
              <button
                type="button"
                className="productSubmission-bulk-import-action"
                onClick={handleBulkImport}
                disabled={!bulkImportFile || bulkImportLoading}
              >
                {bulkImportLoading
                  ? "Processing..."
                  : validateOnly
                    ? "Validate"
                    : "Import"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {AIInhancment ? (
        <div className="ai-inhancment-popup-layer">
          <div className="ai-inhancment-popup-container">
            <div
              className="clos-popup-icon"
              onClick={() => setAIInhancment(false)}
            >
              <XIcon />
            </div>
            <div className="ai-inhancment-popup-header">
              <div className="ai-inhancment-popup-header-icon">
                <SettingsIcon
                  fill="#FFFFFF"
                  stroke="2px"
                  strokeWidth="0.75px"
                />
              </div>
              <div className="ai-inhancment-popup-header-title">
                Artificial Enhancement Settings
              </div>
            </div>
            <div className="ai-inhancment-popup-body">
              <div className="ai-inhancment-popup-body-row">
                <div className="ai-inhancment-popup-body-row-icon">
                  <PicIcon />
                </div>
                <div className="ai-inhancment-popup-body-row-text">
                  <div className="ai-inhancment-popup-body-row-text-header">
                    <div className="ai-inhancment-popup-body-row-text-header-title">
                      Photo Enhancement
                    </div>
                    <div className="ai-inhancment-popup-body-row-text-header-button">
                      <span
                        className={`productSubmission-switch ${
                          photoEnhance ? "active" : ""
                        }`}
                        onClick={() => setPhotoEnhance((p) => !p)}
                      >
                        <span className="productSubmission-switch-thumb" />
                      </span>
                    </div>
                  </div>
                  <div className="ai-inhancment-popup-body-row-text-body">
                    Improve image quality, colors, sharpness , and lighting.
                  </div>
                  <div className="ai-inhancment-popup-body-row-text-body">
                    {getJobSummaryForProduct(
                      selectedProduct?.id || selectedRowIds?.[0],
                      "DIMENSION_IMAGE",
                    ) || "Uses the SKU dimension API when enabled."}
                  </div>
                </div>
              </div>
              <div className="ai-inhancment-popup-body-row">
                <div className="ai-inhancment-popup-body-row-icon">
                  <VideoIcon />
                </div>
                <div className="ai-inhancment-popup-body-row-text">
                  <div className="ai-inhancment-popup-body-row-text-header">
                    <div className="ai-inhancment-popup-body-row-text-header-title">
                      Video Enhancement
                    </div>
                    <div className="ai-inhancment-popup-body-row-text-header-button">
                      <span
                        className={`productSubmission-switch ${
                          videoEnhance ? "active" : ""
                        }`}
                        onClick={() => setVideoEnhance((p) => !p)}
                      >
                        <span className="productSubmission-switch-thumb" />
                      </span>
                    </div>
                  </div>
                  <div className="ai-inhancment-popup-body-row-text-body">
                    Improve image quality, colors, sharpness , and lighting.
                  </div>
                  <div className="ai-inhancment-popup-body-row-text-body">
                    {getJobSummaryForProduct(
                      selectedProduct?.id || selectedRowIds?.[0],
                      "VIDEO_ENHANCEMENT",
                    ) || "Generates video from product photos asynchronously."}
                  </div>
                </div>
              </div>
              <div className="ai-inhancment-popup-body-row">
                <div className="ai-inhancment-popup-body-row-icon">
                  <DocIcon />
                </div>
                <div className="ai-inhancment-popup-body-row-text">
                  <div className="ai-inhancment-popup-body-row-text-header">
                    <div className="ai-inhancment-popup-body-row-text-header-title">
                      Document Enhancement
                    </div>
                    <div className="ai-inhancment-popup-body-row-text-header-button">
                      <span
                        className={`productSubmission-switch ${
                          docEnhance ? "active" : ""
                        }`}
                        onClick={() => setDocEnhance((p) => !p)}
                      >
                        <span className="productSubmission-switch-thumb" />
                      </span>
                    </div>
                  </div>
                  <div className="ai-inhancment-popup-body-row-text-body">
                    Improve image quality, colors, sharpness , and lighting.
                  </div>
                  <div className="ai-inhancment-popup-body-row-text-body">
                    {getJobSummaryForProduct(
                      selectedProduct?.id || selectedRowIds?.[0],
                      "DESCRIPTION_ENHANCEMENT",
                    ) || "Generates description text asynchronously."}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="ai-enhance-footer"
              style={{ padding: "0 28px 28px" }}
            >
              <button
                className="ai-enhance-btn-primary"
                onClick={applySelectedAiEnhancements}
              >
                Apply Selected Enhancements
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {!selectedProduct ? (
        <div className="productSubmission-header">
          <div
            className="productSubmission-header-constainer"
            // style={{
            //   minWidth: "100%",
            //   display: "flex",
            //   flexDirection: "row",
            //   // justifyContent: "flex-start",
            //   alignItems: "flex-start",
            //   paddingTop: "20px",
            //   gap: "10px",
            // }}
          >
            <div className="productSubmission-icon">
              <ProductManagementSubmisionIcon fill={iconFill} />
            </div>
            <div>
              <div className="productSubmission-main-title">
                Product Submission
              </div>
              <div className="productSubmission-main-paragraphe">
                Review, approve, or reject submitted products.
              </div>
            </div>
            <div
              className="productSubmission-bulk-adding-button"
              onClick={() => setBulkProds(true)}
            >
              Bulk Import products
            </div>
          </div>
        </div>
      ) : null}
      {openImagePopup && (
        <div
          className="image-popup-overlay"
          onClick={() => setOpenImagePopup(false)}
        >
          <div
            className="ai-enhance-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-enhance-header">
              <div className="ai-enhance-title">
                <span className="ai-enhance-wand-icon">✦</span>
                <span>AI Image Enhancement</span>
              </div>
              <div
                className="ai-enhance-close"
                onClick={() => setOpenImagePopup(false)}
              >
                <XIcon />
              </div>
            </div>

            <p className="ai-enhance-subtitle">
              Review and enhance product images with artificial intelligence.
            </p>
            <p className="ai-enhance-product-label">
              Product: {activeProduct?.name}
              {activeProduct?.id ? ` - ${activeProduct.id}` : ""}
            </p>
            {activePendingAiJobs.length ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  marginBottom: "12px",
                }}
              >
                {activePendingAiJobs.map((job) => (
                  <div
                    key={String(job?.jobId || "")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      padding: "10px 12px",
                      borderRadius: "10px",
                      background: "#F8FAFC",
                      border: "1px solid #D0D5DD",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#344054",
                        }}
                      >
                        {formatAiJobTypeLabel(job?.jobType)}
                      </span>
                      <span style={{ fontSize: "12px", color: "#667085" }}>
                        {job?.message || "Queued"}
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "#4072C8",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {Math.max(0, Number(job?.progressPercent || 0))}%
                    </span>
                  </div>
                ))}
              </div>
            ) : null}

            <div
              className="ai-enhance-main-image"
              style={{ position: "relative" }}
            >
              {activeImages.length > 0 ? (
                <>
                  {getMediaKind(activeImages[currentIndex]) === "video" ? (
                    <video
                      src={getMediaUrl(activeImages[currentIndex])}
                      controls
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        borderRadius: "12px",
                      }}
                    />
                  ) : (
                    <img
                      src={getMediaUrl(activeImages[currentIndex])}
                      alt={`product-${currentIndex}`}
                    />
                  )}
                  {activePendingAiJob ? (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "12px",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "12px",
                          background: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 6px 18px rgba(16,24,40,0.12)",
                          fontSize: "24px",
                        }}
                      >
                        ↻
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#344054",
                        }}
                      >
                        {activeAiJobMessage}
                      </div>
                      <div style={{ fontSize: "12px", color: "#667085" }}>
                        {formatAiJobTypeLabel(activePendingAiJob?.jobType)} in
                        progress
                      </div>
                    </div>
                  ) : null}
                </>
              ) : (
                <span className="ai-enhance-no-image">No images available</span>
              )}
            </div>

            <div className="ai-enhance-images-section">
              <div className="ai-enhance-images-header">
                <div className="ai-enhance-images-left">
                  <span className="ai-enhance-images-label">
                    Product Attachments
                  </span>
                  <span className="ai-enhance-images-count">
                    {activeImages.length} Attachments
                  </span>
                </div>
                <div className="ai-enhance-images-actions">
                  <input
                    ref={productImageInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    hidden
                    onChange={handleProductImageSelection}
                  />
                  <button
                    className="ai-enhance-add-btn"
                    onClick={() => productImageInputRef.current?.click()}
                    disabled={imageAdding}
                  >
                    {imageAdding ? "Adding..." : "+ Add"}
                  </button>
                  <button
                    className="ai-enhance-delete-btn"
                    onClick={handleDeleteActiveImage}
                    disabled={
                      imageEnhancing ||
                      imageDeleting ||
                      imageAdding ||
                      !activeImages.length
                    }
                  >
                    {imageDeleting ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
              <div className="ai-enhance-thumbnails">
                {activeImages.map((img, i) => (
                  <div
                    key={i}
                    className={`ai-enhance-thumb ${i === currentIndex ? "ai-enhance-thumb-active" : ""}`}
                    onClick={() => setCurrentIndex(i)}
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    {getMediaKind(img) === "video" ? (
                      <>
                        <video
                          src={getMediaUrl(img)}
                          muted
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: "18px",
                            background: "rgba(0,0,0,0.18)",
                          }}
                        >
                          ▶
                        </div>
                      </>
                    ) : (
                      <img
                        className="ai-image-preview"
                        src={getMediaUrl(img)}
                        alt={`thumb-${i}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="ai-enhance-replace-section">
              <div className="ai-enhance-replace-row">
                <span className="ai-enhance-replace-label">
                  Replace Original
                </span>
                <label className="ai-enhance-toggle">
                  <input
                    type="checkbox"
                    checked={replaceOriginal}
                    onChange={() => setReplaceOriginal((v) => !v)}
                  />
                  <span className="ai-enhance-toggle-slider" />
                </label>
              </div>
              <p className="ai-enhance-replace-desc">
                AI enhancement improves image clarity, lighting balance, and
                background quality for professional product presentation.
              </p>
            </div>

            <div className="ai-enhance-footer">
              <button
                className="ai-enhance-btn-primary"
                onClick={handleEnhanceActiveImage}
                disabled={
                  imageEnhancing ||
                  imageDeleting ||
                  !activeImages.length ||
                  getMediaKind(activeImages[currentIndex]) !== "image"
                }
              >
                {imageEnhancing || !!activePendingAiJob
                  ? "Enhancing..."
                  : "Enhance with AI"}
              </button>
              <button
                className="ai-enhance-btn-outline"
                onClick={handleEnhanceAllActiveImages}
                disabled={
                  imageEnhancing || imageDeleting || !activeImages.length
                }
              >
                {imageEnhancing || !!activePendingAiJob
                  ? "Enhancing..."
                  : "Enhance All Images"}
              </button>
            </div>
            {actionError ? (
              <div
                style={{
                  color: "#d92d20",
                  fontSize: "12px",
                  marginTop: "8px",
                }}
              >
                {actionError}
              </div>
            ) : null}
          </div>
        </div>
      )}
      {!selectedProduct ? (
        <>
          <div className="productSubmission-stats-grid">
            {summaryCards.map((item) => (
              <div className="productSubmission-stat-card" key={item.label}>
                <div className="productSubmission-stat-label">{item.label}</div>
                <div
                  className={`productSubmission-stat-value productSubmission-stat-value-${item.tone}`}
                >
                  {item.value}
                </div>
              </div>
            ))}
          </div>
          <div className="productSubmission-actions">
            <div className="productSubmission-actions-row">
              <div className="productSubmission-enhacement-container">
                <div
                  className="productSubmission-ai-toggle"
                  onClick={() => setAIInhancment(true)}
                  style={{ cursor: "pointer" }}
                >
                  AI Enhance Images
                  <span
                    className={`productSubmission-switch ${photoEnhance || videoEnhance || docEnhance ? "active" : ""}`}
                  >
                    <span className="productSubmission-switch-thumb" />
                  </span>
                </div>
              </div>
              <div className="productSubmission-filter-buttons">
                <div
                  className="productSubmission-filter-wrap"
                  ref={filterWrapRef}
                >
                  <GloablButton
                    width="108px"
                    height="40px"
                    backgroundColor="#FFFFFF"
                    text="Filter"
                    color="#424242"
                    borderRadius="999px"
                    padding="6px 12px"
                    boxShadow="inset 0 0 0 1px #D0D5DD"
                    icon={<FilterIcon />}
                    onClick={() => setIsFilterOpen((prev) => !prev)}
                  />
                  {isFilterOpen ? (
                    <div className="filter-popup-container-prod-sub productSubmission-filter-popup">
                      <div className="filter-popup-container-header">
                        Filter
                      </div>
                      <div className="filter-popup-container-body">
                        <div className="filter-popup-container-body-cont">
                          <div className="filter-popup-container-rows filter-popup-container-rows-category">
                            {Utils.parseJwt(userService.getUser()).isRoot ? (
                              <div className="filter-popup-container-rows-title">
                                <div className="filter-popup-rows-title-name">
                                  Only AzaleaProducts
                                </div>
                                <input
                                  type="checkbox"
                                  checked={draftFilters.onlyAzalea}
                                  onChange={(e) =>
                                    setDraftFilters((prev) => ({
                                      ...prev,
                                      onlyAzalea: e.target.checked,
                                    }))
                                  }
                                  className="filter-popup-rows-button"
                                ></input>
                              </div>
                            ) : null}

                            <div className="filter-popup-container-rows-title">
                              <div className="filter-popup-rows-title-name">
                                Search
                              </div>
                              <button
                                type="button"
                                className="filter-popup-rows-button"
                                onClick={() =>
                                  setDraftFilters((prev) => ({
                                    ...prev,
                                    search: "",
                                  }))
                                }
                              >
                                Clear
                              </button>
                            </div>
                            <div className="filter-popup-container-rows-input">
                              <div className="filter-popup-container-rows-icon">
                                <SearchIcon />
                              </div>
                              <input
                                className="filter-popup-container-rows-input-data"
                                placeholder="Search Product, Company Name..."
                                value={draftFilters.search}
                                onChange={(e) =>
                                  setDraftFilters((prev) => ({
                                    ...prev,
                                    search: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>

                          <div className="filter-popup-container-rows">
                            <div className="filter-popup-container-rows-title">
                              <div className="filter-popup-rows-title-name">
                                Filter by User
                              </div>
                              <button
                                type="button"
                                className="filter-popup-rows-button"
                                onClick={() =>
                                  setDraftFilters((prev) => ({ ...prev, employeeName: "" }))
                                }
                              >
                                Clear
                              </button>
                            </div>
                            <div className="filter-popup-container-rows-input">
                              <input
                                className="filter-popup-container-rows-input-data"
                                placeholder="Enter Employee Name"
                                value={draftFilters.employeeName}
                                onChange={(e) =>
                                  setDraftFilters((prev) => ({
                                    ...prev,
                                    employeeName: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>

                          <div className="filter-popup-container-rows-input-date">
                            <DateRangePicker
                              fromValue={draftFilters.from}
                              toValue={draftFilters.to}
                              onRangeChange={handleRangeChange}
                            />
                          </div>

                          <div className="filter-popup-container-rows filter-popup-container-rows-status">
                            <div className="filter-popup-container-rows-title">
                              <div className="filter-popup-rows-title-name">
                                Status
                              </div>
                              <button
                                type="button"
                                className="filter-popup-rows-button"
                                onClick={() =>
                                  setDraftFilters((prev) => ({
                                    ...prev,
                                    status: "",
                                  }))
                                }
                              >
                                Clear
                              </button>
                            </div>

                            <CustomDropdown
                              value={draftFilters.status}
                              onChange={(status) =>
                                setDraftFilters((prev) => ({
                                  ...prev,
                                  status,
                                }))
                              }
                              placeholder="Select Status"
                              rightIcon={<ArrowDownIcon />}
                              options={statusOptions}
                              className="filter-popup-container-rows-input"
                              menuClassName="status-drop-menu-container"
                              optionClassName="status-drop-menu-option"
                            />
                          </div>

                          <div className="filter-popup-container-rows-filter-popup-container-rows-category">
                            <div className="filter-popup-container-rows-title">
                              <div className="filter-popup-rows-title-name">
                                Category
                              </div>
                              <button
                                type="button"
                                className="filter-popup-rows-button"
                                onClick={() => {
                                  setDraftFilters((prev) => ({
                                    ...prev,
                                    category: "",
                                  }));
                                  setShowAllCategories(false);
                                }}
                              >
                                Clear
                              </button>
                            </div>

                            <div className="filter-popup-category-list">
                              {visibleCategoryOptions.map((category) => {
                                const categoryValue = category.categoryId;

                                return (
                                  <label
                                    key={categoryValue}
                                    className="filter-popup-category-option"
                                  >
                                    <input
                                      type="checkbox"
                                      style={{
                                        cursor: "pointer",
                                        width: "12px",
                                      }}
                                      checked={
                                        draftFilters.category === categoryValue
                                      }
                                      onChange={() =>
                                        setDraftFilters((prev) => ({
                                          ...prev,
                                          category:
                                            prev.category === categoryValue
                                              ? ""
                                              : categoryValue,
                                        }))
                                      }
                                    />
                                    <span>{category.categoryName}</span>
                                  </label>
                                );
                              })}

                              {!showAllCategories &&
                              categoryOptions.length > 3 ? (
                                <button
                                  type="button"
                                  className="filter-popup-category-show-more"
                                  onClick={() => setShowAllCategories(true)}
                                >
                                  Show more
                                </button>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="filter-popup-container-footer">
                          <div className="filter-popup-footer-action-bottons">
                            <button
                              type="button"
                              className="filter-popup-footer-clear-bottons"
                              onClick={clearAllFilters}
                            >
                              Clear All
                            </button>
                            <button
                              type="button"
                              className="filter-popup-footer-apply-bottons"
                              onClick={applyAllFilters}
                            >
                              Apply All
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="productSubmission-action">
                  <GloablButton
                    width="159px"
                    height="40px"
                    backgroundColor="#FFFFFF"
                    text="Export/Print"
                    color="#424242"
                    borderRadius="999px"
                    padding="6px 12px"
                    boxShadow="inset 0 0 0 1px #D0D5DD"
                    icon={<ExportAndPrintIcon />}
                    onClick={openExportPrintModal}
                  />
                </div>
                {/* <div className="productSubmission-action">
                  <GloablButton
                    width="190px"
                    height="40px"
                    backgroundColor={
                      selectedRowIds.length && !bulkDeleteLoading
                        ? "#F44336"
                        : "#FFFFFF"
                    }
                    text={
                      bulkDeleteLoading
                        ? "Deleting..."
                        : selectedRowIds.length
                          ? `Delete Selected (${selectedRowIds.length})`
                          : "Delete Selected"
                    }
                    color={
                      selectedRowIds.length && !bulkDeleteLoading
                        ? "#FFFFFF"
                        : "#98A2B3"
                    }
                    borderRadius="999px"
                    padding="6px 12px"
                    boxShadow="inset 0 0 0 1px #F44336"
                    icon={
                      <TrashIcon
                        w="14px"
                        h="15px"
                        fill={
                          selectedRowIds.length && !bulkDeleteLoading
                            ? "#FFFFFF"
                            : "#98A2B3"
                        }
                      />
                    }
                    onClick={handleDeleteSelectedProducts}
                    disabled={!selectedRowIds.length || bulkDeleteLoading}
                  />
                </div> */}
              </div>
            </div>
          </div>
          {actionError ? (
            <div className="productSubmission-main-paragraphe">
              {actionError}
            </div>
          ) : null}
        </>
      ) : null}

      {selectedProduct ? (
        <div className="productSubmission-view-shell-countainer">
          {actionError ? (
            <div className="productSubmission-main-paragraphe">
              {actionError}
            </div>
          ) : null}

          <div className="productSubmission-view-topbar">
            <div className="productSubmission-view-topbar-grid">
              <div>
                <div className="productSubmission-view-pill-label">
                  Product Name
                </div>
                <div className="productSubmission-view-pill-value">
                  {selectedProduct.name}
                </div>
              </div>
              <div>
                <div className="productSubmission-view-pill-label">
                  Submitted By
                </div>
                <div className="productSubmission-view-pill-value">
                  {selectedProduct.submittedBy}
                </div>
              </div>
              <div>
                <div className="productSubmission-view-pill-label">
                  Submitted Date
                </div>
                <div className="productSubmission-view-pill-value">
                  {formatDateOnlyLabel(submittedDateTime)}
                </div>
              </div>
              <div>
                <div className="productSubmission-view-pill-label">Status</div>
                <div className="productSubmission-view-pill-value">
                  <span
                    className={`productSubmission-status productSubmission-status-${selectedProduct.status.toLowerCase()}`}
                  >
                    {selectedProduct.status}
                  </span>
                </div>
              </div>
            </div>

            <div className="productSubmission-view-topbar-actions">
              <button
                type="button"
                className="productSubmission-view-action-btn productSubmission-view-action-btn-resubmit"
                onClick={openResubmitPopup}
              >
                <ResubmitIcon />
                Resubmit
              </button>
              <button
                type="button"
                className="productSubmission-view-action-btn productSubmission-view-action-btn-reject"
                onClick={openRejectPopup}
              >
                <RejectedIcon />
                Reject
              </button>
              <button
                type="button"
                className="productSubmission-view-action-btn productSubmission-view-action-btn-approve"
                onClick={openApprovePopup}
              >
                <ApprovedIcon />
                Approve
              </button>
            </div>
          </div>

          <div className="productSubmission-view-content-row">
            <div className="productSubmission-view-product-images-wrap">
              <div className="productSubmission-view-product-images-title">
                Product Images
              </div>
              <div className="productSubmission-view-product-images-box">
                <div className="productSubmission-view-product-images-grid">
                  {resolvedProductImageSources.length > 0 ? (
                    resolvedProductImageSources.map((src, index) => (
                      <img
                        key={`${src}-${index}`}
                        src={src}
                        alt={`${selectedProduct.name} ${index + 1}`}
                        onClick={() => setPreviewImageSrc(src)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            setPreviewImageSrc(src);
                          }
                        }}
                      />
                    ))
                  ) : (
                    <div className="productSubmission-view-basic-info-value">
                      No images (UI-only)
                    </div>
                  )}
                </div>
                {resolvedProductImageSources.length > 0 ? (
                  <div className="productSubmission-view-product-images-footer">
                    <div
                      className="productSubmission-ai-toggle"
                      onClick={() => setAIInhancment(true)}
                      style={{ cursor: "pointer" }}
                    >
                      AI Enhance Images
                      <span
                        className={`productSubmission-switch ${photoEnhance || videoEnhance || docEnhance ? "active" : ""}`}
                      >
                        <span className="productSubmission-switch-thumb" />
                      </span>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="productSubmission-view-basic-info-wrap">
                <div className="productSubmission-view-basic-info-title">
                  Basic Product Information
                </div>
                <div className="productSubmission-view-basic-info-box">
                  <div className="productSubmission-view-basic-info-grid">
                    <div className="productSubmission-view-basic-info-item">
                      <div className="productSubmission-view-basic-info-label">
                        Product Name
                      </div>
                      <div className="productSubmission-view-basic-info-value">
                        {basicInfo?.productName || selectedProduct.name || "-"}
                      </div>
                    </div>
                    <div className="productSubmission-view-basic-info-item">
                      <div className="productSubmission-view-basic-info-label">
                        Category
                      </div>
                      <div className="productSubmission-view-basic-info-value">
                        {basicInfo?.categoryName ||
                          getCategoryNameById(
                            basicInfo?.categoryId || basicInfo?.category,
                          ) ||
                          selectedProduct.category ||
                          "-"}
                      </div>
                    </div>
                    <div className="productSubmission-view-basic-info-item">
                      <div className="productSubmission-view-basic-info-label">
                        Brand
                      </div>
                      <div className="productSubmission-view-basic-info-value">
                        {basicInfo?.brand || "-"}
                      </div>
                    </div>
                    <div className="productSubmission-view-basic-info-item">
                      <div className="productSubmission-view-basic-info-label">
                        Country of Production
                      </div>
                      <div className="productSubmission-view-basic-info-value">
                        {basicInfo?.countryOfProduction || "-"}
                      </div>
                    </div>
                    <div className="productSubmission-view-basic-info-item">
                      <div className="productSubmission-view-basic-info-label">
                        PRICE
                      </div>
                      <div className="productSubmission-view-basic-info-value">
                        {skuEntries[0]?.price ?? "-"}
                      </div>
                    </div>
                  </div>

                  <div className="productSubmission-view-basic-info-description">
                    <div className="productSubmission-view-basic-info-label">
                      Description
                    </div>
                    <div className="productSubmission-view-basic-info-value">
                      {basicInfo?.description || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="productSubmission-commercial-wrap">
                <div className="productSubmission-commercial-head">
                  <div className="productSubmission-commercial-title">
                    Commercial Data (SKU List)
                  </div>
                  <div className="productSubmission-commercial-count">
                    {skuEntries.length} SKUs Listed
                  </div>
                </div>

                {skuEntries.map((entry, index) => (
                  <div
                    className="productSubmission-commercial-card"
                    key={String(entry?.id || entry?.sku || `sku-${index}`)}
                  >
                    <div className="productSubmission-sku-top-strip">
                      <span className="productSubmission-sku-top-strip-label">
                        {entry?.id || `SKU ENTRY #${index + 1}`}
                      </span>
                      <span className="productSubmission-sku-top-strip-value">
                        {entry?.sku || "-"}
                      </span>
                    </div>

                    <div className="productSubmission-view-basic-info-box-2">
                      <div className="productSubmission-commercial-grid">
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Size
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.size)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Model
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.model)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Material
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.material)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Color
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {/* {formatRenderableValue(entry?.colorInfo)} */}
                            {skuEntries[0]?.colorInfo[0]?.colorName}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Stock Quantity
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.stockQuantity)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Unit of Measure
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.unitOfMeasure)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Barcode
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.barcode)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Azalea Barcode
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.azaleaBarcode)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Product Dimensions
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.productDimensions)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Package Dimensions
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.packageDimensions)}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Product Weight
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatWeightValue(
                              entry?.productWeight,
                              entry?.productWeightUnitOfMeasure,
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            Package Weight
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatWeightValue(
                              entry?.packageWeight,
                              entry?.packageWeightUnitOfMeasure,
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="productSubmission-view-basic-info-label">
                            SKU
                          </div>
                          <div className="productSubmission-view-basic-info-value">
                            {formatRenderableValue(entry?.sku)}
                          </div>
                        </div>
                      </div>

                      <div className="productSubmission-commercial-tech">
                        <div className="productSubmission-view-basic-info-label">
                          Technical Specifications
                        </div>
                        <div className="productSubmission-view-basic-info-value">
                          {formatRenderableValue(entry?.technicalSpecs)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="productSubmission-brd-side">
              <div className="productSubmission-brd-card-internal">
                <div className="productSubmission-brd-card-title">
                  <InternalNotesIcon />
                  Internal Notes
                </div>

                <textarea
                  className="productSubmission-brd-box"
                  value={internalNotes}
                  maxLength={INTERNAL_NOTES_MAX_LENGTH}
                  onChange={(e) => setLimitedInternalNotes(e.target.value)}
                  // onBlur={saveInternalNotes}
                  placeholder="Write internal notes here... (Only visible to admins)"
                  spellCheck={false}
                  disabled={notesSaving}
                />

                <div className="productSubmission-brd-counter">
                  {String(internalNotes || "").length}/
                  {INTERNAL_NOTES_MAX_LENGTH}
                </div>

                <div className="productSubmission-brd-hint">
                  Only visible to admins
                </div>
              </div>

              <div
                className="productSubmission-brd-card-internal"
                onMouseEnter={() => setShowChangeHistory(true)}
                onMouseLeave={() => setShowChangeHistory(false)}
              >
                <div className="productSubmission-brd-card-title">
                  <ReviewActiveLog />
                  Review Activity Log
                </div>

                <div className="productSubmission-brd-review-box">
                  <div className="productSubmission-brd-review-row">
                    <div>
                      <div className="productSubmission-brd-k">Reviewer</div>
                      <div className="productSubmission-brd-v2">
                        {reviewerName}
                      </div>
                    </div>

                    <div>
                      <div className="productSubmission-brd-k">Assigned On</div>
                      <div className="productSubmission-brd-v2">
                        {formatDateTimeLabel(assignedOn)}
                      </div>
                    </div>
                  </div>

                  <div className="productSubmission-brd-review-row">
                    <div>
                      <div className="productSubmission-brd-k">
                        Last Activity
                      </div>
                      <div className="productSubmission-brd-v2">
                        {formatDateTimeLabel(lastActivity)}
                      </div>
                    </div>

                    <div>
                      <div className="productSubmission-brd-k">
                        Current Status
                      </div>
                      <div className="productSubmission-brd-v2">
                        <span
                          className={detailBadgeClass(
                            selectedProduct?.status || "-",
                          )}
                        >
                          {selectedProduct?.status || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {showChangeHistory && (
                  <div className="productSubmission-brd-history">
                    <div className="productSubmission-brd-history-title">
                      Change History
                    </div>

                    {changeHistory.length ? (
                      changeHistory.map((log, index) => (
                        <div
                          key={log?.activityLogId || `history-${index}`}
                          className="productSubmission-brd-history-item"
                        >
                          <div className="productSubmission-brd-history-head">
                            <span className="productSubmission-brd-history-action">
                              {formatRenderableValue(log?.action)}
                            </span>
                            <span className="productSubmission-brd-k">
                              {formatDateTimeLabel(log?.performedAt)}
                            </span>
                          </div>
                          <div className="productSubmission-brd-v2">
                            {formatRenderableValue(log?.performedBy)}
                          </div>
                          {Array.isArray(log?.changes) &&
                            log.changes.length > 0 && (
                              <ul className="productSubmission-brd-history-changes">
                                {log.changes.map((change, changeIndex) => (
                                  <li key={changeIndex}>
                                    {formatHistoryChange(change)}
                                  </li>
                                ))}
                              </ul>
                            )}
                        </div>
                      ))
                    ) : (
                      <div className="productSubmission-brd-k">
                        No history yet
                      </div>
                    )}
                  </div>
                )}

                <div className="productSubmission-brd-hint">
                  Only visible to admins
                </div>
              </div>

              {/* Video Upload */}
              <div className="productSubmission-brd-card-internal">
                <div className="productSubmission-brd-card-title">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 6C4 4.89543 4.89543 4 6 4H14L20 10V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
                      stroke="#667085"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 4V10H20"
                      stroke="#667085"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Upload File
                </div>

                {/* Drop zone */}
                <div
                  className={`video-upload-dropzone ${videoDragging ? "video-upload-dropzone-active" : ""}`}
                  onClick={() => videoInputRef.current?.click()}
                  onDragOver={(e) => {
                    e.preventDefault();
                    setVideoDragging(true);
                  }}
                  onDragLeave={() => setVideoDragging(false)}
                  onDrop={(e) => {
                    e.preventDefault();
                    setVideoDragging(false);
                    const file = e.dataTransfer.files?.[0];
                    if (file) setVideoFile(file);
                  }}
                >
                  <UploadButtonIcon />
                  <p className="video-upload-dropzone-title">
                    {videoFile ? videoFile.name : "Drag & drop your video here"}
                  </p>
                  {!videoFile && (
                    <p className="video-upload-dropzone-sub">
                      or click to browse files
                    </p>
                  )}
                  <p className="video-upload-dropzone-hint">
                    Supported Formats: MP4, AVI, WebM
                    <br />
                    Maximum file size: 500MB
                  </p>
                  <input
                    ref={videoInputRef}
                    type="file"
                    accept="video/mp4,video/avi,video/webm"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) setVideoFile(file);
                    }}
                  />
                </div>

                <button
                  className="video-upload-btn"
                  disabled={!videoFile}
                  onClick={() => {
                    AddVideoToProduct();
                  }}
                >
                  Upload Video
                </button>

                {/* URL section */}
                <div className="video-url-label">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.18997"
                      stroke="#667085"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 11C13.5705 10.4259 13.0226 9.95087 12.3934 9.60711C11.7643 9.26334 11.0685 9.05888 10.3533 9.00766C9.63819 8.95645 8.92038 9.05964 8.24864 9.31018C7.5769 9.56072 6.96689 9.95296 6.46 10.46L3.46 13.46C2.54918 14.403 2.04520 15.666 2.05660 16.977C2.06800 18.288 2.59383 19.5421 3.52087 20.4691C4.44791 21.3962 5.70198 21.922 7.01296 21.9334C8.32394 21.9448 9.58695 21.4408 10.53 20.53L12.24 18.82"
                      stroke="#667085"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Video URL
                </div>
                <input
                  type="url"
                  className="video-url-input"
                  placeholder="https://youtube.com/... or https://vimeo.com/..."
                  value={videoUrl}
                  onChange={(e) => setVideoUrl(e.target.value)}
                />
                <p className="video-url-hint">Enter a Vimeo or Youtube link.</p>

                <button
                  className="video-upload-btn"
                  disabled={!videoUrl.trim()}
                  onClick={() => {
                    AddVideoToProduct();
                  }}
                >
                  Add Video
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="productSubmission-table-container">
            <table className="productSubmission-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      aria-label="Select all products"
                      checked={isAllCurrentRowsSelected}
                      onChange={(e) =>
                        handleSelectAllCurrentRows(e.target.checked)
                      }
                    />
                  </th>
                  <th>Product Name</th>
                  <th>Company Name</th>
                  <th>Submitted By</th>
                  <th>Date Created</th>
                  <th>Category</th>
                  <th>Images</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {displayedRows.length === 0 ? (
                  <tr>
                    <td colSpan={9}>
                      {listLoading
                        ? "Loading product requests..."
                        : "No product requests found."}
                    </td>
                  </tr>
                ) : null}

                {currentRows.map((product, index) => (
                  <tr
                    className="productSubmission-table-row"
                    key={`${product.id || product.name}-${(currentPage - 1) * rowsPerPage + index}`}
                  >
                    <td className="productSubmission-cell-select">
                      <input
                        type="checkbox"
                        aria-label={`Select ${product.name} product`}
                        checked={selectedRowIds.includes(String(product.id))}
                        onChange={(e) =>
                          toggleRowSelection(product.id, e.target.checked)
                        }
                      />
                    </td>
                    <td className="productSubmission-cell-name">
                      {truncateProductName(product.name)}
                    </td>
                    <td className="productSubmission-cell-sku">
                      {truncateSku(product.companyName)}
                    </td>
                    <td className="productSubmission-cell-submitted-by">
                      <span className="productSubmission-submitter-avatar">
                        {String(product.submittedBy || "?")
                          .trim()
                          .charAt(0)
                          .toUpperCase()}
                      </span>
                      <span className="productSubmission-submitter-name">
                        {product.submittedBy}
                      </span>
                    </td>
                    <td className="productSubmission-cell-date">
                      <span className="productSubmission-meta-icon">
                        <DateIcon strokeWidth="1.2" />
                      </span>
                      <span>{product.dateCreated}</span>
                    </td>
                    <td className="productSubmission-cell-category">
                      {product.category}
                    </td>
                    <td className="productSubmission-cell-images">
                      <div className="product-images-cell">
                        <div
                          className="productSubmission-meta-icon"
                          onClick={() => handleProductDetail(product)}
                          style={{ cursor: "pointer" }}
                        >
                          <CameraIcon />
                        </div>
                        <div>{product.raw?.images.length} image</div>
                      </div>
                    </td>
                    <td className="productSubmission-cell-status">
                      <span
                        className={`productSubmission-status productSubmission-status-${String(product.status || "").toLowerCase()}`}
                      >
                        {product.status}
                      </span>
                    </td>
                    <td className="productSubmission-cell-actions">
                      <div className="productSubmission-row-action">
                        <div
                          className="productSubmission-view-btn"
                          style={{ cursor: "pointer" }}
                          onClick={(event) =>
                            toggleRowActionMenu(product.id, event)
                          }
                          role="button"
                          tabIndex={0}
                          aria-label={`Open actions for ${product.name}`}
                        >
                          <PointIcon />
                        </div>

                        {openActionMenuId === product.id
                          ? createPortal(
                              <div
                                className="productSubmission-actions-menu"
                                style={actionMenuPosition}
                              >
                                <div
                                  className="productSubmission-actions-menu-item"
                                  onClick={() => openProductView(product)}
                                  role="button"
                                  tabIndex={0}
                                >
                                  <span className="productSubmission-actions-menu-icon">
                                    <EyeView />
                                  </span>
                                  <span className="productSubmission-actions-menu-label">
                                    View Details
                                  </span>
                                </div>

                                {Utils.parseJwt(userService.getUser()).isRoot &&
                                userService.getCompID() ===
                                  product.raw.companyId ? (
                                  <a
                                    className="productSubmission-actions-menu-item"
                                    href={buildUrl(
                                      createProductEditNavigation(product).path,
                                      currentTableState,
                                    )}
                                    onClick={(e) => {
                                      e.preventDefault();

                                      const editNavigation =
                                        createProductEditNavigation(product);
                                      const returnUrl = buildUrl(
                                        "/product-submissions",
                                        currentTableState,
                                      );

                                      window.history.replaceState(
                                        window.history.state,
                                        "",
                                        returnUrl,
                                      );
                                      saveProductSubmissionTableState(
                                        currentTableState,
                                      );
                                      markProductSubmissionReturnPending();

                                      navigateWithTableState(
                                        editNavigation.path,
                                        currentTableState,
                                        {
                                          state: editNavigation.state,
                                        },
                                      );
                                    }}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    <span className="productSubmission-actions-menu-icon">
                                      <EditDetails />
                                    </span>

                                    <span className="productSubmission-actions-menu-label">
                                      Edit Product
                                    </span>
                                  </a>
                                ) : null}
                                <div
                                  className="productSubmission-actions-menu-item"
                                  onClick={() =>
                                    handleDownloadFromActions(product)
                                  }
                                  role="button"
                                  tabIndex={0}
                                >
                                  <div className="productSubmission-actions-menu-icon">
                                    <DownloadIcon />
                                  </div>
                                  <span className="productSubmission-actions-menu-label">
                                    Download
                                  </span>
                                </div>

                                <div
                                  className="productSubmission-actions-menu-item"
                                  onClick={() =>
                                    handlePrintFromActions(product)
                                  }
                                  role="button"
                                  tabIndex={0}
                                >
                                  <div className="productSubmission-actions-menu-icon">
                                    <PrintIcon />
                                  </div>
                                  <span className="productSubmission-actions-menu-label">
                                    Print QR
                                  </span>
                                </div>

                                {Utils.parseJwt(userService.getUser()).isRoot &&
                                userService.getCompID() ===
                                  product.raw.companyId ? (
                                  <div
                                    className="productSubmission-actions-menu-item productSubmission-actions-menu-item-delete"
                                    onClick={() => DeleteProduct(product.id)}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    <span className="productSubmission-actions-menu-icon">
                                      <TrashIcon fill="red" />
                                    </span>

                                    <span className="productSubmission-actions-menu-label">
                                      Delete
                                    </span>
                                  </div>
                                ) : null}
                              </div>,
                              document.body,
                            )
                          : null}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="productSubmission-table-footer">
            <div className="productSubmission-rows-select">
              <span className="productSubmission-rows-label">
                Rows per page
              </span>
              <select
                className="productSubmission-rows-btn"
                value={rowsPerPage}
                onChange={(e) => {
                  const nextSize = Number(e.target.value) || 10;
                  setRowsPerPage(nextSize);
                  setCurrentPage(1);
                  setPageInputValue("");
                }}
                aria-label="Rows per page"
              >
                {rowsPerPageOptions.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
              <span>of {totalRows} rows</span>
            </div>

            <div className="productSubmission-pagination-controls">
              <form
                className="productSubmission-page-input-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  goToTypedPage();
                }}
              >
                <input
                  type="number"
                  min="1"
                  max={totalPages}
                  className="productSubmission-page-input"
                  value={
                    isPageInputFocused ? pageInputValue : String(currentPage)
                  }
                  onFocus={(e) => {
                    setIsPageInputFocused(true);
                    setPageInputValue(String(currentPage));
                    e.target.select();
                  }}
                  onChange={(e) => setPageInputValue(e.target.value)}
                  onBlur={() => {
                    if (!goToTypedPage()) {
                      setPageInputValue("");
                      setIsPageInputFocused(false);
                    }
                  }}
                  aria-label="Go to page"
                />
              </form>

              <div className="productSubmission-pagination">
                <button
                  type="button"
                  className="productSubmission-page-btn"
                  onClick={goToPreviousPage}
                  disabled={currentPage === 1}
                >
                  <ArrowBackIcon />
                </button>

                {getVisiblePaginationItems().map((item, index) => {
                  if (item === "...") {
                    return (
                      <button
                        key={`pagination-dots-${index}`}
                        type="button"
                        className="productSubmission-page-btn"
                        disabled
                      >
                        ...
                      </button>
                    );
                  }

                  const pageNumber = item;

                  return (
                    <button
                      key={pageNumber}
                      type="button"
                      className={`productSubmission-page-btn ${
                        currentPage === pageNumber
                          ? "productSubmission-page-btn-active"
                          : ""
                      }`}
                      onClick={() => {
                        setCurrentPage(pageNumber);
                        setPageInputValue("");
                        setIsPageInputFocused(false);
                      }}
                    >
                      {pageNumber}
                    </button>
                  );
                })}

                <button
                  type="button"
                  className="productSubmission-page-btn"
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                >
                  <ArrowFront />
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {isExportModalOpen &&
        createPortal(
          <div
            className="productSubmission-export-overlay"
            onClick={() => setIsExportModalOpen(false)}
          >
            <div
              className="productSubmission-export-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="productSubmission-export-close"
                onClick={() => setIsExportModalOpen(false)}
                aria-label="Close export modal"
              >
                <CloseIcon />
              </button>

              <div className="productSubmission-export-title">
                Export & Print
              </div>
              <div className="productSubmission-export-subtitle">
                Choose export format and options
              </div>

              <div className="productSubmission-export-format-grid">
                {exportFormatOptions.map((option) => (
                  <button
                    key={option.key}
                    type="button"
                    className={`productSubmission-export-format-card ${exportFormat === option.key ? "is-active" : ""}`}
                    onClick={() => setExportFormat(option.key)}
                  >
                    <div className="productSubmission-export-format-icon">
                      {option.key === "PRINT" ? (
                        <PrintIcon />
                      ) : (
                        <DownloadIcon />
                      )}
                    </div>
                    <div className="productSubmission-export-format-title">
                      {option.title}
                    </div>
                    <div className="productSubmission-export-format-subtitle">
                      {option.subtitle}
                    </div>
                  </button>
                ))}
              </div>

              <div className="productSubmission-export-scope-list">
                {[
                  {
                    key: "ALL",
                    title: "All Submissions",
                    subtitle: "Export all product submissions in the database",
                  },
                  {
                    key: "FILTERED",
                    title: "Filtered Results",
                    subtitle:
                      "Export only submissions matching current filters",
                  },
                  {
                    key: "SELECTED",
                    title: "Selected Rows",
                    subtitle: "Export only manually selected submissions",
                  },
                ].map((scope) => (
                  <button
                    key={scope.key}
                    type="button"
                    className={`productSubmission-export-scope-item ${exportScope === scope.key ? "is-active" : ""}`}
                    onClick={() => setExportScope(scope.key)}
                    disabled={
                      scope.key === "SELECTED" && !selectedRowIds.length
                    }
                  >
                    <input
                      type="checkbox"
                      checked={exportScope === scope.key}
                      readOnly
                    />
                    <span>
                      <strong>{scope.title}</strong>
                      <small>{scope.subtitle}</small>
                    </span>
                  </button>
                ))}
              </div>

              <div className="productSubmission-export-summary">
                <div className="productSubmission-export-summary-title">
                  Export Summary
                </div>
                <ul>
                  <li>Format: {exportFormat}</li>
                  <li>Records: {exportRecordCount}</li>
                  <li>Status Filter: {appliedFilters.status || "Any"}</li>
                  <li>Product Info: Yes</li>
                </ul>
              </div>

              <div className="productSubmission-export-footer">
                <GloablButton
                  width="180px"
                  height="42px"
                  backgroundColor="#4072C8"
                  text={exportActionLabel}
                  borderRadius="999px"
                  padding="8px 14px"
                  boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                  onClick={handleExportAction}
                />
                <GloablButton
                  width="115px"
                  height="42px"
                  backgroundColor="#FFFFFF"
                  text="Cancel"
                  color="#344054"
                  borderRadius="999px"
                  padding="8px 14px"
                  boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.25)"
                  onClick={() => setIsExportModalOpen(false)}
                />
              </div>
            </div>
          </div>,
          document.body,
        )}

      {previewImageSrc
        ? createPortal(
            <div
              className="productSubmission-image-preview-overlay"
              onClick={() => setPreviewImageSrc("")}
            >
              <div
                className="productSubmission-image-preview-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="productSubmission-export-close"
                  onClick={() => setPreviewImageSrc("")}
                  aria-label="Close image preview"
                >
                  <CloseIcon />
                </button>
                <img
                  className="productSubmission-image-preview-full"
                  src={previewImageSrc}
                  alt="Product preview"
                />
              </div>
            </div>,
            document.body,
          )
        : null}

      {isPrintConfigOpen &&
        createPortal(
          <div
            className="productSubmission-export-overlay"
            onClick={() => setIsPrintConfigOpen(false)}
          >
            <div
              className="productSubmission-print-config-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="productSubmission-export-close"
                onClick={() => setIsPrintConfigOpen(false)}
                aria-label="Close print configuration"
              >
                <CloseIcon />
              </button>

              <div className="productSubmission-print-config-left">
                <div className="productSubmission-export-title">
                  Print Configuration
                </div>
                <div className="productSubmission-export-subtitle">
                  Select Barcode Size
                </div>

                <div className="productSubmission-print-size-list">
                  {printSizeOptions.map((option) => (
                    <button
                      key={option.key}
                      type="button"
                      className={`productSubmission-print-size-item ${printSize === option.key ? "is-active" : ""}`}
                      onClick={() => setPrintSize(option.key)}
                    >
                      <input
                        type="checkbox"
                        checked={printSize === option.key}
                        readOnly
                      />
                      <span>
                        <strong>{option.label}</strong>
                        <small>{option.size}</small>
                      </span>
                    </button>
                  ))}
                </div>

                <div className="productSubmission-print-tip">
                  The preview on the right shows relative scale of QR code.
                </div>
              </div>

              <div className="productSubmission-print-config-right">
                <div className="productSubmission-export-subtitle productSubmission-print-preview-label">
                  Visual Scale Preview
                </div>
                <div className="productSubmission-print-preview-shell">
                  {printPreviewSrc ? (
                    <img
                      src={printPreviewSrc}
                      alt="Print preview"
                      className="productSubmission-print-preview-image"
                      style={{
                        width: `${Math.max(64, getPrintSizeMm(printSize) * 2.2)}px`,
                        height: `${Math.max(64, getPrintSizeMm(printSize) * 2.2)}px`,
                      }}
                    />
                  ) : (
                    <div className="productSubmission-print-preview-image" />
                  )}
                </div>
                <div className="productSubmission-print-preview-name">
                  {selectedProduct?.sku ||
                    currentRows?.[0]?.sku ||
                    "PRODUCT-001"}
                </div>
                <div className="productSubmission-print-preview-title">
                  {selectedProduct?.name || currentRows?.[0]?.name || "Product"}
                </div>
                <div className="productSubmission-print-preview-size">
                  {printSizeLabel}
                </div>

                <div className="productSubmission-export-footer">
                  <GloablButton
                    width="190px"
                    height="42px"
                    backgroundColor="#4072C8"
                    text="Proceed to Print"
                    borderRadius="999px"
                    padding="8px 14px"
                    boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                    onClick={handleProceedPrint}
                  />
                  <GloablButton
                    width="115px"
                    height="42px"
                    backgroundColor="#FFFFFF"
                    text="Cancel"
                    color="#344054"
                    borderRadius="999px"
                    padding="8px 14px"
                    boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.25)"
                    onClick={() => setIsPrintConfigOpen(false)}
                  />
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}

      {isResubmitPopupOpen
        ? createPortal(
            <div
              className="productSubmission-resubmit-overlay"
              onClick={closeResubmitPopup}
            >
              <div
                className="productSubmission-resubmit-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="productSubmission-resubmit-icon-wrap">
                  <div className="productSubmission-resubmit-icon">
                    <ResubmitionYellow />
                  </div>
                </div>
                <div className="productSubmission-resubmit-title">
                  Request Re-submission
                </div>
                <div className="productSubmission-resubmit-subtitle">
                  Ask the submitter to make corrections to "
                  {selectedProduct?.name || "this product"}"
                </div>
                <div className="productSubmission-resubmit-alert">
                  The submission will remain in pending status until corrections
                  are made.
                </div>

                <div className="productSubmission-resubmit-field">
                  <label htmlFor="required-resubmission">
                    <span className="productSubmission-resubmit-field-icon" />
                    Required Re-submission
                  </label>
                  <textarea
                    id="required-resubmission"
                    value={resubmitReason}
                    onChange={(e) => setResubmitReason(e.target.value)}
                    placeholder="Describe what corrections need to be made..."
                  />
                </div>

                <label className="productSubmission-resubmit-checkbox">
                  <input
                    type="checkbox"
                    checked={notifySubmitter}
                    onChange={(e) => setNotifySubmitter(e.target.checked)}
                  />
                  Notify submitter via email
                </label>

                <div className="productSubmission-resubmit-actions">
                  <GloablButton
                    width="160px"
                    height="44px"
                    backgroundColor="#4072C8"
                    text={actionLoading ? "Sending..." : "Confirm & Send"}
                    borderRadius="50px"
                    padding="11.0527px 18.4211px"
                    gap="7.37px"
                    boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                    onClick={handleConfirmResubmission}
                  />
                  <GloablButton
                    width="90px"
                    height="44px"
                    backgroundColor="#FFFFFF"
                    text="Cancel"
                    color="#344054"
                    borderRadius="50px"
                    padding="11.0527px 18.4211px"
                    gap="7.37px"
                    boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                    onClick={closeResubmitPopup}
                  />
                </div>
              </div>
            </div>,
            document.body,
          )
        : null}

      {isRejectOpen &&
        createPortal(
          <div
            className="productSubmission-popup-rejected-overlay"
            onClick={closeRejectPopup}
          >
            <div
              className="productSubmission-popup-rejected-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="productSubmission-popup-icon-wrap">
                <div className="productSubmission-popup-icon productSubmission-popup-icon-danger">
                  <TrachIcon />
                </div>
              </div>

              <div className="productSubmission-popup-rejected-title">
                Reject Submission
              </div>
              <div className="productSubmission-popup-rejected-subtitle">
                You are about to reject the product submission.
              </div>

              <div className="productSubmission-popup-reject-info">
                <span className="productSubmission-popup-reject-info-item">
                  Product: {selectedProduct?.name || "-"}
                </span>
                <span className="productSubmission-popup-reject-info-item">
                  Submitted By: {selectedProduct?.submittedBy || "-"}
                </span>
              </div>

              <div className="productSubmission-popup-reject-warning">
                <Worning />
                <span>
                  The submitter will be notified and asked to make corrections.
                </span>
              </div>

              <div className="productSubmission-popup-reject-reason-card">
                <label className="productSubmission-popup-reject-label">
                  <FaulseIcon />
                  <span>
                    Reason for Rejection <strong>*</strong>
                  </span>
                </label>

                <textarea
                  className="productSubmission-popup-rejectedtextarea"
                  value={rejectReason}
                  onChange={(e) => {
                    setRejectReason(e.target.value);
                    if (rejectValidationError) setRejectValidationError("");
                  }}
                  placeholder="Explain why this submission is being rejected..."
                />
              </div>

              {rejectValidationError ? (
                <div className="productSubmission-main-paragraphe">
                  {rejectValidationError}
                </div>
              ) : null}

              <div className="productSubmission-popup-reject-checkbox">
                <input
                  type="checkbox"
                  checked={notifyRejectSubmitter}
                  onChange={(e) => setNotifyRejectSubmitter(e.target.checked)}
                />
                <span>Notify submitter via email</span>
              </div>

              <div className="productSubmission-popup-resubmit-footer">
                <GloablButton
                  width="182px"
                  height="44px"
                  backgroundColor="#F44336"
                  text={actionLoading ? "Rejecting..." : "Confirm Rejection"}
                  borderRadius="50px"
                  padding="11.0527px 18.4211px"
                  gap="7.37px"
                  boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                  onClick={handleConfirmRejection}
                />

                <GloablButton
                  width="115px"
                  height="44px"
                  backgroundColor="#FFFFFF"
                  text="Cancel"
                  color="#344054"
                  borderRadius="50px"
                  padding="11.0527px 18.4211px"
                  gap="7.37px"
                  boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                  onClick={closeRejectPopup}
                />
              </div>
            </div>
          </div>,
          document.body,
        )}

      {isApproveOpen &&
        createPortal(
          <div
            className="productSubmission-approve-overlay"
            onClick={() => setIsApproveOpen(false)}
          >
            <div
              className="productSubmission-approve-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="productSubmission-approve-icon-wrap">
                <div className="productSubmission-approve-icon">
                  <ApprovedBigIcon />
                </div>
              </div>

              <div className="productSubmission-approve-title">
                Approve Submission
              </div>
              <div className="productSubmission-approve-subtitle">
                You are about to approve the product submission.
              </div>

              <div className="productSubmission-approve-summary">
                <div className="productSubmission-approve-summary-item">
                  <span className="productSubmission-approve-summary-label">
                    Product:
                  </span>
                  <span>{selectedProduct?.name || "-"}</span>
                </div>
                <div className="productSubmission-approve-summary-item">
                  <span className="productSubmission-approve-summary-label">
                    Submitted By:
                  </span>
                  <span>{selectedProduct?.submittedBy || "-"}</span>
                </div>
              </div>

              <div className="productSubmission-approve-warning">
                This product will be added to the catalog and become available
                for sale.
              </div>

              <div className="productSubmission-approve-notes">
                <label htmlFor="approval-notes">
                  Approval Notes (Optional)
                </label>
                <textarea
                  id="approval-notes"
                  value={approveNotes}
                  onChange={(e) => setApproveNotes(e.target.value)}
                  placeholder="Add any notes about this approval..."
                />
              </div>

              <label className="productSubmission-approve-checkbox">
                <input
                  type="checkbox"
                  checked={approveNotifySubmitter}
                  onChange={(e) => setApproveNotifySubmitter(e.target.checked)}
                />
                Notify submitter via email
              </label>

              <div className="productSubmission-approve-footer">
                <GloablButton
                  width="219px"
                  height="44px"
                  backgroundColor="#039855"
                  text="Approve Submission"
                  color="#FFFFFF"
                  borderRadius="50px"
                  padding="11.0527px 18.4211px"
                  gap="7.37px"
                  boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                  onClick={handleConfirmApproval}
                />

                <GloablButton
                  width="115px"
                  height="44px"
                  backgroundColor="#FFFFFF"
                  text="Cancel"
                  color="#344054"
                  borderRadius="50px"
                  padding="11.0527px 18.4211px"
                  gap="7.37px"
                  boxShadow="inset 0px -1px 3px rgba(0, 18, 71, 0.5)"
                  onClick={() => setIsApproveOpen(false)}
                />
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}

export default ProductSubmission;